import RouterPath from "libs/RouterPath";
import {devMode} from "../libs/isDevMode";
import pjson from '../../package.json'

const redirect_uri = window.location.origin + RouterPath.baseRoute;

let SERVER_URL = window.location.origin

if (devMode) {
    SERVER_URL = "http://localhost/app-ezam";
    //nie można innych używać, bo przeszliśmy na sesję http a jeśli różne domeny to sa różne sesje
    //jak coś gtrzeba skonfigurowac lokalne proxy https://confluence.marketplanet.pl/pages/viewpage.action?pageId=19693610
}

const EXT_JS_LIBRARIES = {
    jquery: SERVER_URL + "/js/jquery-3.3.1.min.js?v=" + encodeURIComponent(pjson.version),
    szafir: SERVER_URL + "/js/signature/szafirsdk-module.js?v=" + encodeURIComponent(pjson.version)
}


const BASE = SERVER_URL + "/api"
const BASE_MP = SERVER_URL + "/mp"

const oauth = {
    AUTHORIZE: (state) => BASE_MP + `/oauth/authorize?client_id=mp&response_type=code&state=${state}&redirect_uri=${redirect_uri}`,
    TOKEN: BASE_MP + '/oauth/token',
    LOGOUT: `${BASE}/oauth/logout`
}

const base = {
    BASE,
    DEMANDS: BASE + "/demands",
    DEMAND: BASE + "/demand",
    RFX: BASE + "/rfx",
    CPV_LIST: BASE + '/cpv/list',
    MEASURE_UNITS: BASE + '/measureUnitTypes/list',
    DEALINGS: BASE + '/dealings',
    ITEMS: BASE + '/items',
    USER: BASE + '/user',
    SALES: BASE + '/sales',
    POLL: BASE + '/poll',
    UPLOAD: (csrf, encryptRoundId) => `${SERVER_URL}/repository/upload/api${encryptRoundId ? "/encrypt?roundId=" + encryptRoundId + "&" : "?"}CSRFToken=${csrf}`,
    //UPLOAD: (csrf) => `${BASE}/upload?CSRFToken=${csrf}`,
    ESPD: BASE + '/espd',
    PURCHASING_GROUP: BASE + "/purchasingGroup",
    ADMIN: BASE + "/admin",
    CHANG_LANGUAGE: (language, country, csrf, backUrl) => `${SERVER_URL}/servlet/HomeServlet?MP_module=common&MP_action=changeLocale&language=${language}&country=${country}&CSRFToken=${csrf}&backUrl=${encodeURIComponent(backUrl)}`,
    AUDIT: BASE + '/audit',
    ENOTICES: BASE + '/enotices',
    AGREEMENT: BASE + '/agreement'
}

const sales = {
    SALES_NOTIFICATION_SEND: (functionalityName) => `${base.SALES}/notification/${functionalityName}/send`
}

const poll = {
    POLL_SAVE_RATING: () => `${base.POLL}`,
    POLL_GET: (pollType) => `${base.POLL}/${pollType}`
}

const DEMAND_BASE = (id) => `${base.DEMAND}/${id}`;
const RFX_BASE = (id) => `${base.RFX}/${id}`;

const __DEMAND_AUTOSAVE = (id) => base.DEMAND + "/autoSave/" + id;
const __DEMAND_EXPOST_AUTOSAVE = (id) => base.DEMAND + "/exPost/autoSave/" + id;
const demand = {
    DEMAND_SAVE: base.DEMAND + "/save",
    DEMAND_SAVE_EX_POST: base.DEMAND + "/exPost/save",
    DEMAND_GET_NEW: (params) => base.DEMAND + `/-1${params}`,
    DEMAND_GET_BY_ID: (id, params) => `${DEMAND_BASE(id)}${params}`,
    DEMAND_COMMISION_USER_HISTORY: (id) => base.DEMAND + `/${id}/commission/users/history`,
    DEMAND_AUTOSAVE: (id) => __DEMAND_AUTOSAVE(id),
    DEMAND_AUTOSAVE_CHECK: (id) => __DEMAND_AUTOSAVE(id) + '/check',
    DEMAND_EXPOST_AUTOSAVE: (id) => __DEMAND_EXPOST_AUTOSAVE(id),
    DEMAND_EXPOST_AUTOSAVE_CHECK: (id) => __DEMAND_EXPOST_AUTOSAVE(id) + '/check',
    DEMAND_PREVIEW: (id) => DEMAND_BASE(id) + '/preview',
    DEMAND_ACTIONS: (id) => `${DEMAND_BASE(id)}/actions`,
    DEMAND_DELETE: (id) => `${DEMAND_BASE(id)}/delete`,
    DEMAND_CLONE: (id) => `${DEMAND_BASE(id)}/clone`,
    DEMAND_REALTED_OBJECTS: (id) => `${DEMAND_BASE(id)}/relatedObjects`,
    DEMAND_PRIVILEGES: (id) => `${DEMAND_BASE(id)}/privileges`,
    DEMAND_RFX_PRIVILEGES: (id) => `${DEMAND_BASE(id)}/rfxPrivileges`,
    DEMAND_UPDATE_NUMBER: (id) => `${DEMAND_BASE(id)}/updateNumber`
}

const DEALINGS = (id) => `${base.DEALINGS}/${id}`
const DEALINGS_AUTOSAVE_DEALING = (id, dealingId) => DEALINGS(id) + '/autoSaveDealing/' + (dealingId)

const dealings = {
    DEALINGS,
    DEALINGS_SINGLE: (demandId, dealingId) => DEALINGS(demandId) + '/' + dealingId,
    DEALINGS_LIST: (demandId) => DEALINGS(demandId) + '/list',
    DEALINGS_SAVE: (id) => DEALINGS(id) + '/save',
    DEALINGS_VALIDATE: (id) => DEALINGS(id) + '/validate',
    DEALINGS_DELETE: (id) => DEALINGS(id) + '/delete',
    DEALINGS_AUTOSAVE: (id, dealingId) => DEALINGS_AUTOSAVE_DEALING(id, dealingId),
    DEALINGS_AUTOSAVE_CHECK: (id, dealingId) => DEALINGS_AUTOSAVE_DEALING(id, dealingId) + '/check',
    DEALINGS_AUTOSAVE_BATCH: (id) => DEALINGS(id) + '/autoSaveDealing',
    DEALINGS_IMPORT: (id) => DEALINGS(id) + '/import',
    DEALINGS_EXPORT: (id) => DEALINGS(id) + '/export',
    DEALINGS_WITH_CRITERION: (demandId, critId) => DEALINGS(demandId) + `/criterion/${critId}/matching`,
    DEALINGS_MATCHING_CRITERION: (demandId, stageId, criteriumType) => DEALINGS(demandId) + `/stage/${stageId}/criterium/${criteriumType}/matching`
}

const DEALING = (id) => `${base.DEMAND}/${id}/dealing`;

const dealing = {
    DEALING_REALIZATION_VALUE: (demandId) => `${DEALING(demandId)}/realizationValue`,
    DEALING_FINAL_REALIZATION_VALUE: (demandId) => `${DEALING(demandId)}/finalRealizationValue`,
    DEALING_REALIZATION_VALUE_STATUS: (demandId) => `${DEALING(demandId)}/realizationValueStatus`,
    DEALING_REALIZATION_VALUE_PUBLISH: (demandId) => `${DEALING(demandId)}/realizationOfferAmount/publish`,
    DEALING_REALIZATION_VALUE_UNPUBLISH: (demandId) => `${DEALING(demandId)}/realizationOfferAmount/unpublish`,
}

const PAPERS_GENERATOR = (id) => `${DEMAND_BASE(id)}/papersGenerator`;

const PAPERS_GENERATOR_PRINT = (identity, paper) => `${SERVER_URL}/servlet/HomeServlet?MP_module=common&MP_action=papersGeneratorPrinter&paper=${paper}&identity=${identity}`;
const PAPERS_GENERATOR_PRINT_SHARE = (identity, paper, shareSystem) => `${SERVER_URL}/servlet/HomeServlet?MP_module=common&MP_action=papersGeneratorPrinter&paper=${paper}&identity=${identity}&shareSystem=${shareSystem}`;
const PAPERS_GENERATOR_PRINT_SHARE_HISTORY_LAST = (identity, paper) => `${PAPERS_GENERATOR(identity)}/${paper}/share/history/last`;
const PAPERS_GENERATOR_PRINT_SHARE_HISTORY = (identity, paper, system) => `${PAPERS_GENERATOR(identity)}/${paper}/share/history/${system}`;
const PAPERS_GENERATOR_DEMAND_REPORT = (identity, report) => `${SERVER_URL}/servlet/HomeServlet?MP_module=demand&MP_action=${report}&demandIdentity=${identity}`;

const PAPERS_GENERATOR_DEMAND_ATTACHMENT_VERIFICATION_REPORT = (demandId) => `${SERVER_URL}/app/rfx/${demandId}/offer/attachment/verify/report`;
const PAPERS_GENERATOR_CORRESPONDENCE_ATTACHMENT_VERIFICATION_REPORT = (demandId) => `${SERVER_URL}/app/rfx/correspondence/buyer/${demandId}/supplier/attachments/printVerification/report`;
const PAPERS_GENERATOR_DEMAND_PROCESS_HISTORY = (demandId) => `${SERVER_URL}/servlet/HomeServlet?MP_module=demand&MP_action=demandPrintProcessHistory&documentIdentity=${demandId}&documentType=DEMAND&processConfigName=Demand`;
const PAPERS_GENERATOR_DEMAND_APPROVAL_HISTORY = (demandId) => `${SERVER_URL}/servlet/HomeServlet?MP_module=demand&MP_action=demandInternalApiApprovalPrintHistory&demandIdentity=${demandId}`;

const papersGenerator = {
    PAPERS_GENERATOR,
    RFX_REQUEST_POSITION: (id) => PAPERS_GENERATOR(id) + `/rfxRequestPosition`,
    SWZ_PARAMS: (id) => PAPERS_GENERATOR(id) + `/swzParams`,
    RFX_INVITED_SUPPLIER_WITH_OFFER: (id) => PAPERS_GENERATOR(id) + `/rfxInvitedSupplierWithOffer`,
    RFX_INVITED_SUPPLIER_POSITION: (id, supplierId) => PAPERS_GENERATOR(id) + `/${supplierId}/rfxInvitedSupplierPosition`,
    SIWZ_GET_GENERATOR_PARAMS: (id) => PAPERS_GENERATOR(id) + `/swzParams`,
    XMM_UZP_PRESIDENT_PAPER: (id) => PAPERS_GENERATOR(id) + `/xmlUzpPresidentPaper`,
    GET_SUPPLIER_ATTACHMENTS_VERIFICATION: (id, supplierId) => PAPERS_GENERATOR(id) + `/${supplierId}/supplierAttachmentsVerification`,
    PAPERS_GENERATOR_PRINT,
    PAPERS_GENERATOR_PRINT_SHARE,
    PAPERS_GENERATOR_PRINT_SHARE_HISTORY_LAST,
    PAPERS_GENERATOR_PRINT_SHARE_HISTORY,
    PAPERS_GENERATOR_DEMAND_REPORT,
    PAPERS_GENERATOR_DEMAND_ATTACHMENT_VERIFICATION_REPORT,
    PAPERS_GENERATOR_CORRESPONDENCE_ATTACHMENT_VERIFICATION_REPORT,
    PAPERS_GENERATOR_DEMAND_PROCESS_HISTORY,
    PAPERS_GENERATOR_DEMAND_APPROVAL_HISTORY,
    PAPERS_GENERATOR_OFFER_FILES_SIGNATURE_VERIFICATION: (demandId) => PAPERS_GENERATOR(demandId) + '/verifyAttachments'
}

const EMAIL_LIST = (id) => `${DEMAND_BASE(id)}/emailList`;

const emailList = {
    EMAIL_LIST,
    EMAIL_LIST_ACTIONS: (demandId) => `${EMAIL_LIST(demandId)}/actions`,
    EMAIL_DETAILS: (demandId, emailId) => `${EMAIL_LIST(demandId)}/${emailId}/details`,
    EMAIL_PRINT: (demandId, emailId) => `${EMAIL_LIST(demandId)}/${emailId}/print`,
}

const SCHEDULE = (id) => `${DEMAND_BASE(id)}/schedule`;

const schedule = {
    SCHEDULE,
    SCHEDULE_AUTOSAVE: (id) => SCHEDULE(id) + '/autoSave/' + id,
    SCHEDULE_AUTOSAVE_CHECK: (id) => SCHEDULE(id) + '/autoSave/' + id + '/check',
    SCHEDULE_SAVE: (id) => SCHEDULE(id) + '/save',
    SCHEDULE_CALCULATE_STAGE_DATES: (id) => SCHEDULE(id) + '/calculateStageDates',
    SCHEDULE_VALIDATE: (id) => SCHEDULE(id) + '/validate',
}

const COMMISSION = (id) => `${base.DEMAND}/${id}/commission/users`;

const commission = {
    COMMISSION,
    COMMISSION_AUTOSAVE: (demandId) => COMMISSION(demandId) + `/autoSave/${demandId}`,
    COMMISSION_AUTOSAVE_CHECK: (demandId) => COMMISSION(demandId) + `/autoSave/${demandId}/check`,
    COMMISSION_VALIDATE: (id) => COMMISSION(id) + '/validate',
    COMMISSION_AVAILABLE: (id) => COMMISSION(id) + `/available`,
    COMMISSION_HISTORY: (id) => COMMISSION(id) + `/history`,
    COMMISSION_DELETE_COMMISION_MEMBER: (demandId, id) => COMMISSION(demandId) + `/${id}`,
    COMMISSION_MARK_HISTORICAL_MEMBER: (demandId, id) => COMMISSION(demandId) + `/markHistorical/${id}`,
    COMMISSION_EXTERNAL: `${base.BASE}/commission/external-users`,
}

const GUARANTEE = (id) => `${base.DEMAND}/${id}/guarantee`;
const GUARANTEE_AUTOSAVE = (id) => `${GUARANTEE(id)}/autoSave/${id}`;

const guarantee = {
    GUARANTEE,
    GUARANTEE_VALIDATE: (id) => GUARANTEE(id) + '/validate',
    GUARANTEE_AUTOSAVE: (id) => GUARANTEE_AUTOSAVE(id),
    GUARANTEE_AUTOSAVE_CHECK: (id) => GUARANTEE_AUTOSAVE(id) + '/check'
}

const ESPD = (id) => `${base.ESPD}/${id}`;
const ESPD_AUTOSAVE = (id) => `${base.ESPD}/autoSave/${id}`;

const espd = {
    ESPD,
    ESPD_SAVE: (id) => ESPD(id) + `/save`,
    ESPD_VALIDATE: (id) => ESPD(id) + '/validate',
    ESPD_AUTOSAVE: (id) => ESPD_AUTOSAVE(id),
    ESPD_AUTOSAVE_CHECK: (id) => ESPD_AUTOSAVE(id) + `/check`,
    ESPD_EXPORT_FOR_DEMAND: (dealingId) => `${ESPD(dealingId)}/export`,
    ESPD_EXPORT_FOR_DEALING: (demandId, dealingId) => `${ESPD(demandId)}/dealing/${dealingId}/export`,
    ESPD_PRINT_FOR_DEMAND: (dealingId) => `${ESPD(dealingId)}/print`,
    ESPD_PRINT_FOR_DEALING: (demandId, dealingId) => `${ESPD(demandId)}/dealing/${dealingId}/print`,
}

const CONTRACTOR = (id) => `${DEMAND_BASE(id)}/contractor`;
const CONTRACTOR_INVITE = (id) => CONTRACTOR(id) + '/invite';

const contractor = {
    CONTRACTOR_ADD: (id) => CONTRACTOR(id) + '/add',
    CONTRACTOR_GET_LIST: (id) => CONTRACTOR(id) + '/list',
    CONTRACTOR_GET_DETAILS: (id, contractorDepartmentId) => CONTRACTOR(id) + `/getContractorData/${contractorDepartmentId}`,
    CONTRACTOR_REMOVE: (id) => CONTRACTOR(id) + '/remove',
    CONTRACTOR_ONEPLACE: (id) => CONTRACTOR(id) + `/onePlace`,
    CONTRACTOR_VALIDATE: (id) => CONTRACTOR(id) + '/validate',
    CONTRACTOR_INVITE,
    CONTRACTOR_CHECK: (id) => CONTRACTOR_INVITE(id) + '/check',
    CONTRACTOR_GET_NIP_LIST: (id) => CONTRACTOR_INVITE(id) + '/nipprefix',
    CONTRACTOR_REPORT: (id, contractorNIP, postCode) => CONTRACTOR(id) + `/kys/report/generate/${contractorNIP}/${postCode}`,
    CONTRACTOR_REPORT_HISTORY: (id, contractorNIP, postCode) => CONTRACTOR(id) + `/kys/report/history/${contractorNIP}/${postCode}`,
    CONTRACTOR_DOWNLOAD_REPORT: (id, reportId) => CONTRACTOR(id) + `/kys/report/${reportId}`
}

const CONTRACTOR_VERIFICATION = (id) => `${DEMAND_BASE(id)}/evaluation/contractor`;
const contractorVerification = {
    CONTRACTOR_VERIFICATION_LIST: (id) => CONTRACTOR_VERIFICATION(id) + "/list",
    CONTRACTOR_VERIFICATION_STATUS: (id) => CONTRACTOR_VERIFICATION(id) + "/status",
    CONTRACTOR_VERIFICATION_PROCEDURE: (id) => CONTRACTOR_VERIFICATION(id) + "/procedure",
    CONTRACTOR_VERIFICATION_VALIDATE: (id) => CONTRACTOR_VERIFICATION(id) + "/validate",
    CONTRACTOR_VERIFICATION_REPORT: (id, contractorNIP, postCode) => CONTRACTOR_VERIFICATION(id) + `/kys/report/generate/${contractorNIP}/${postCode}`,
    CONTRACTOR_VERIFICATION_REPORT_HISTORY: (id, contractorNIP, postCode) => CONTRACTOR_VERIFICATION(id) + `/kys/report/history/${contractorNIP}/${postCode}`,
    CONTRACTOR_VERIFICATION_DOWNLOAD_REPORT: (id, reportId) => CONTRACTOR_VERIFICATION(id) + `/kys/report/download/${reportId}`
}

const user = {
    USER_DATA: base.USER + '/data',
    USER_PROFILE: base.USER + '/profile',
    USER_LOGGED_MENU_LIST: base.USER + '/logged/menu/list',
    USER_SESSION_TIME: base.USER + '/sessionTime',
    USER_SERVER_TIME: base.USER + '/serverTime',
}

const header = {
    HEADER: (id) => DEMAND_BASE(id) + '/header'
}

const client = {
    CLIENT_LOGO: BASE + '/client/logo',
    CLIENT_COLORS: BASE + '/client/colors'
}

const publish = {
    PUBLISH_DEMAND: (id) => DEMAND_BASE(id) + '/publish',
    IS_PUBLISH_DEMAND: (id) => DEMAND_BASE(id) + '/published',
    PUBLISH_OJS_NOTICE: (id) => DEMAND_BASE(id) + '/publication/ojs/publish',
    ROLLBACK_OJS_NOTICE: (id) => DEMAND_BASE(id) + '/publication/ojs/rollback',
    CHECK_OJS_NOTICE: (id) => DEMAND_BASE(id) + '/publication/ojs/status',
    CHECK_PUBLICATION_LIMIT: (id) => DEMAND_BASE(id) + '/publication/checkLimit',
    PUBLISH_DEMAND_EX_POST: (id) => DEMAND_BASE(id) + '/exPost/goToFinish',
    DEMAND_BACK_TO_PREPARING: (id) => DEMAND_BASE(id) + '/publication/backToPreparing'
}

const NOTICE = (id) => `${DEMAND_BASE(id)}/notice`;

const notice = {
    NOTICE,
    NOTICE_PREVIEW: (id) => NOTICE(id) + '/preview',
    NOTICE_DOWNLOAD_PREVIEW: (id) => NOTICE(id) + '/printPreview', //print instead of download
    NOTICE_VALIDATE: (id) => NOTICE(id) + '/validate',
}

const SIWZ = (demandId) => `${base.DEMAND}/${demandId}/siwz`;
const SIWZ_ID = (demandId, id, source) => `${SIWZ(demandId)}/${source}/${id}`;

const siwz = {
    SIWZ,
    SIWZ_MOVE_FROM_REPO: (demandId) => SIWZ(demandId) + '/moveFromRepo',
    SIWZ_VALIDATE: (demandId) => SIWZ(demandId) + '/validate',
    SIWZ_VALIDATE_DOCUMENTS: (demandId) => SIWZ(demandId) + '/validate/documents',
    SIWZ_ID,
    SIWZ_ID_DOWNLOAD_HISTORY: (demandId, id, source) => SIWZ_ID(demandId, id, source) + `/downloadHistory`,
    SIWZ_ID_UPDATE_DESCRIPTION: (demandId, id, source) => SIWZ_ID(demandId, id, source) + `/updateDescription`,
    SIWZ_ID_UPDATE_NOTICE_REFERENCE_NUMBER: (demandId, id, source) => SIWZ_ID(demandId, id, source) + `/updateNoticeNumber`,
    SIWZ_ID_UPDATE_SHARE: (demandId, id, source) => SIWZ_ID(demandId, id, source) + `/share`,
    SIWZ_ID_UPDATE_SHARE_HISTORY_LAST: (demandId, id, source) => SIWZ_ID(demandId, id, source) + `/share/history/last`,
    SIWZ_ID_UPDATE_SHARE_HISTORY: (demandId, id, source, system) => SIWZ_ID(demandId, id, source) + `/share/history/${system}`,
    SIWZ_ID_UPDATE_STATUS: (demandId, id, source) => SIWZ_ID(demandId, id, source) + `/updateStatus`,
    SIWZ_ID_PUBLISH: (demandId, id, source) => SIWZ_ID(demandId, id, source) + `/publish`,
    SIWZ_ID_VERSIONS: (demandId, id, source) => SIWZ_ID(demandId, id, source) + `/versions`,
    SIWZ_ID_UNPUBLISH: (demandId, id, source) => SIWZ_ID(demandId, id, source) + `/unpublish`,
    SIWZ_ID_GET_DOWNLOAD_URL: (demandId, id, source, openInBrowser) => SIWZ_ID(demandId, id, source) + `/url/${openInBrowser ? 'open' : 'download'}`,
    SIWZ_EDITABLE: (demandId) => SIWZ(demandId) + '/editable',
    SIWZ_TYPES: (demandId) => SIWZ(demandId) + `/types`,
    SIWZ_DOWNLOAD_ALL: (demandId) => SIWZ(demandId) + `/downloadZip`,
    SIWZ_ADD_BZP_NOTICE: (demandId) => SIWZ(demandId) + `/bzpNotice`,
    SIWZ_POST_PRINT_SWZ: (demandId) => SIWZ(demandId) + `/printSwz`,
    SIWZ_POST_SHARE_SWZ: (demandId) => SIWZ(demandId) + `/shareSwz`,
}

const STATISTIC_CURRENT_ROUND = (demandId) => `${base.DEMAND}/${demandId}/statistic/getCurrentRound`;
const STATISTIC = (demandId, roundId) => `${base.DEMAND}/${demandId}/statistic/${roundId}`;

const statistic = {
    STATISTIC_CURRENT_ROUND,
    STATISTIC,
}

const SUPPLIERS = (demandId, roundId) => `${base.DEMAND}/${demandId}/rfx/${roundId}/supplier`;
const supplier = {
    SUPPLIERS_ADD: (demandId, roundId) => `${SUPPLIERS(demandId, roundId)}/add`,
    SUPPLIERS_INVITE: (demandId, roundId) => `${SUPPLIERS(demandId, roundId)}/invite`,
    SUPPLIERS_LIST: (demandId, roundId) => `${SUPPLIERS(demandId, roundId)}/list`,
    SUPPLIERS_CHANGE_EXTERNAL_SIGN: (demandId, roundId, supplierId) => `${SUPPLIERS(demandId, roundId)}/${supplierId}/externalOfferSign`
}

const rfxRound = {
    RFX_ROUND_CANCEL: (roundId) => `${RFX_BASE(roundId)}/cancel`,
    RFX_ROUND_CLOSE: (roundId) => `${RFX_BASE(roundId)}/close`,
    RFX_ROUND_PRIVILEGES: (roundId) => `${RFX_BASE(roundId)}/privileges`,
}

const RFX_OFFERS_BASE = (roundId) => `${RFX_BASE(roundId)}/offer`;
const RFX_DECRYPTION_BASE = (roundId) => `${RFX_BASE(roundId)}/decryption`;
const offers = {
    RFX_OFFERS_LIST: (roundId) => `${RFX_OFFERS_BASE(roundId)}/list`,
    RFX_OFFERS_SEND_INVITE: (roundId) => `${RFX_OFFERS_BASE(roundId)}/sendInvite`,
    RFX_OFFERS_ATTACHMENTS: (roundId) => `${RFX_OFFERS_BASE(roundId)}/attachments`,
    RFX_OFFERS_VERIFY_ATTACHMENTS: (roundId) => `${RFX_OFFERS_BASE(roundId)}/verifyAttachments`,
    RFX_OFFERS_ENVELOPE: (roundId) => `${RFX_OFFERS_BASE(roundId)}/envelope`,
    RFX_OFFERS_ENVELOPE_ID: (roundId, offerEnvelopeId) => `${RFX_OFFERS_BASE(roundId)}/envelope/${offerEnvelopeId}`,
    RFX_OFFERS_UPDATED_BIND_WITH_THE_OFFER_DATE: (roundId) => `${RFX_OFFERS_BASE(roundId)}/updateBindWithTheOfferDate`,
    RFX_OFFERS_ADDITIONAL_ROUND_OFFERS: (roundId, supplierId) => `${RFX_OFFERS_BASE(roundId)}/supplier/${supplierId}/additionalRoundOffers`,
    RFX_OFFERS_ACTIONS: (roundId) => `${RFX_OFFERS_BASE(roundId)}/actions`,
    RFX_OFFERS_SUMMARY: (roundId, type) => `${RFX_OFFERS_BASE(roundId)}/summary/${type}`,
    RFX_OFFERS_PUBLIC_SESSION_START: (roundId) => `${RFX_DECRYPTION_BASE(roundId)}/processPublicSession`,
    RFX_OFFERS_PUBLIC_SESSION_STATUS: (roundId) => `${RFX_DECRYPTION_BASE(roundId)}/publicSessionStatus`,
    RFX_OFFERS_PUBLIC_SESSION_PROGRESS: (roundId) => `${RFX_DECRYPTION_BASE(roundId)}/publicSessionProgress`,
    RFX_OFFERS_DECRYPTION_START: (roundId) => `${RFX_DECRYPTION_BASE(roundId)}/processOfferDecryption`,
    RFX_OFFERS_DECRYPTION_STATUS: (roundId) => `${RFX_DECRYPTION_BASE(roundId)}/offerDecryptionStatus`,
    RFX_OFFERS_DECRYPTION_STATUS_LIGHT: (roundId) => `${RFX_DECRYPTION_BASE(roundId)}/offerDecryptionStatusLight`,
    RFX_OFFERS_DECRYPTION_PROGRESS: (roundId) => `${RFX_DECRYPTION_BASE(roundId)}/offerDecryptionProgress`,
    RFX_OFFERS_PUBLIC_SESSION_ONLINE_SAVE: (roundId) => `${RFX_DECRYPTION_BASE(roundId)}/saveSessionOnline`,
    RFX_OFFERS_PUBLIC_SESSION_ONLINE_STATUS: (roundId) => `${RFX_DECRYPTION_BASE(roundId)}/publicSessionOnlineStatus`
}

const REPO = (demandId) => `${DEMAND_BASE(demandId)}/repo`;
const REPO_FOLDER = (demandId, folderId) => REPO(demandId) + `/folder/${folderId}`;
const REPO_FILE = (demandId, fileId) => REPO(demandId) + `/file/${fileId}`;

const repo = {
    REPO,
    REPO_EDITABLE: (demandId) => REPO(demandId) + "/editable",
    REPO_PUBLISH_OPENING_OFFER_FOLDER: (demandId) => REPO(demandId) + "/publishOpeningOfferFolder",
    REPO_VISIBILITY_TYPES: (demandId) => REPO(demandId) + "/visibilityTypes",
    REPO_CONTRACTORS: (demandId) => REPO(demandId) + "/contractors",
    REPO_FOLDER,
    REPO_FILES_VISIBILITY: (demandId, folderId) => REPO_FOLDER(demandId, folderId) + "/filesVisibility",
    REPO_FOLDER_SHARE: (demandId, folderId) => REPO_FOLDER(demandId, folderId) + "/share",
    REPO_DOWNLOAD_ALL: (demandId, folderId) => REPO_FOLDER(demandId, folderId) + "/downloadZip",
    REPO_DELETE_ALL_FOLDER_FILES: (demandId, folderId) => REPO_FOLDER(demandId, folderId) + "/allFiles",
    REPO_FILE,
    REPO_FILE_VISIBILITY: (demandId, fileId) => REPO_FILE(demandId, fileId) + "/visibility",
    REPO_FILE_SHARE: (demandId, fileId) => REPO_FILE(demandId, fileId) + "/share",
    REPO_FILE_SHARE_HISTORY_LAST: (demandId, fileId) => REPO_FILE(demandId, fileId) + "/share/history/last",
    REPO_FILE_SHARE_HISTORY: (demandId, fileId, system) => REPO_FILE(demandId, fileId) + `/share/history/${system}`,
    REPO_FILE_DOWNLOAD_HISTORY: (demandId, fileId) => REPO_FILE(demandId, fileId) + "/downloadHistory",
    REPO_FILE_UPDATE_DESCRIPTION: (demandId, fileId) => REPO_FILE(demandId, fileId) + "/updateDescription",
    REPO_FILE_GET_DOWNLOAD_URL: (demandId, fileId, openInBrowser) => REPO_FILE(demandId, fileId) + `/url/${openInBrowser ? 'open' : 'download'}`
}

const DEMAND_MODIFICATION = (demandId) => `${DEMAND_BASE(demandId)}/modify`;

const modification = {
    DEMAND_MODIFICATION,
    DEMAND_MODIFICATION_PUBLISH: (demandId) => DEMAND_MODIFICATION(demandId) + "/publish",
    DEMAND_MODIFICATION_CANCEL: (demandId) => DEMAND_MODIFICATION(demandId) + "/rollback",
    DEMAND_MODIFICATION_PUBLISH_OJS: (demandId) => DEMAND_MODIFICATION(demandId) + "/ojs/publish",
    DEMAND_MODIFICATION_ROLLBACK_OJS: (demandId) => DEMAND_MODIFICATION(demandId) + "/ojs/rollback",
    DEMAND_MODIFICATION_OJS_STATUS: (demandId) => DEMAND_MODIFICATION(demandId) + "/ojs/status",
    DEMAND_MODIFICATION_CHANGED: (demandId) => DEMAND_MODIFICATION(demandId) + "/changed",
    DEMAND_BACK_TO_MODIFICATION: (id) => DEMAND_MODIFICATION(id) + '/backToModification'
}

const DEMAND_SECTIONS = (demandId) => `${DEMAND_BASE(demandId)}/sections`;

const sections = {
    DEMAND_PREPARING_SECTIONS: (demandId) => `${DEMAND_SECTIONS(demandId)}/preparing`,
    DEMAND_EVALUATION_SECTIONS: (demandId) => `${DEMAND_SECTIONS(demandId)}/evaluation`,
    DEMAND_FINISHING_SECTIONS: (demandId) => `${DEMAND_SECTIONS(demandId)}/finishing`
}

const OFFER_EVALUATION = (demandId) => `${DEMAND_BASE(demandId)}/evaluation/offer`;

const offerEvaluation = {
    OFFER_EVALUATION_LIST: (demandId, viewMode, roundType) => `${OFFER_EVALUATION(demandId)}/${viewMode}/${roundType}`,
    OFFER_EVALUATION_LIST_UPDATE_STATUS: (demandId, viewMode, roundType) => `${OFFER_EVALUATION(demandId)}/${viewMode}/${roundType}/changeOfferStatus`,
    OFFER_EVALUATION_LIST_UPDATE_SCORE: (demandId, viewMode, roundType) => `${OFFER_EVALUATION(demandId)}/${viewMode}/${roundType}/changeCriterionScore`,
    OFFER_EVALUATION_POSITION_WITH_OPTION: (demandId) => `${OFFER_EVALUATION(demandId)}/positionsWithOption`,
    OFFER_EVALUATION_VALIDATE: (demandId) => `${OFFER_EVALUATION(demandId)}/validate`
}


const OFFER_CHOICE = (demandId) => `${DEMAND_BASE(demandId)}/evaluation/choice`;

const offerChoice = {
    OFFER_CHOICE: (demandId) => `${OFFER_CHOICE(demandId)}`,
    OFFER_CHOICE_CANCEL_WHERE_NO_OFFERS: (demandId) => `${OFFER_CHOICE(demandId)}/cancelWhereNoOffers`,
    OFFER_CHOICE_POSITIONS_WITH_NO_OFFER: (demandId) => `${OFFER_CHOICE(demandId)}/positionWithNoOffer`,
    OFFER_CHOICE_PREPARE_ADDITIONAL_ROUND: (demandId, roundType) => `${OFFER_CHOICE(demandId)}/prepareAdditionalRound/${roundType.toLowerCase()}`,
    OFFER_CHOICE_PREPARE_AUCTION_INFO: (demandId, positionId) => `${OFFER_CHOICE(demandId)}/prepareAuctionInfo/${positionId}`,
    OFFER_CHOICE_REVOKE: (demandId, positionId) => `${OFFER_CHOICE(demandId)}/position/${positionId}/revoke`,
    OFFER_CHOICE_CREATE_ADDITIONAL_ROUND: (demandId) => `${OFFER_CHOICE(demandId)}/createAdditionalRound`,
    OFFER_CHOICE_GET_POSITION: (demandId, positionId) => `${OFFER_CHOICE(demandId)}/position/${positionId}`,
    OFFER_CHOICE_VALIDATE: (demandId) => `${OFFER_CHOICE(demandId)}/validate`,
    OFFER_CHOICE_JUSTIFICATIONS: (demandId) => `${OFFER_CHOICE(demandId)}/choiceJustificationBasis`,
    OFFER_CHOICE_PRIMARY_CHECK: (demandId) => `${OFFER_CHOICE(demandId)}/primaryTenderPathChoice/check`,
    OFFER_CHOICE_PRIMARY_DO_NEGOTIATIONS: (demandId) => `${OFFER_CHOICE(demandId)}/primaryTenderPathChoice/doNegotiations`,
    OFFER_CHOICE_PRIMARY_DO_OFFER_CHOICE: (demandId) => `${OFFER_CHOICE(demandId)}/primaryTenderPathChoice/chooseOffers`,
}

const OFFER_CHOICE_APPROVAL_BASE = (demandId) => `${DEMAND_BASE(demandId)}/evaluation/choice/approval`;

const offerChoiceApproval = {
    OFFER_CHOICE_APPROVAL: OFFER_CHOICE_APPROVAL_BASE,
    OFFER_CHOICE_APPROVAL_SELECT_APPROVERS: (demandId) => `${OFFER_CHOICE_APPROVAL_BASE(demandId)}/selectApprovers`,
    OFFER_CHOICE_APPROVAL_SEND_DECISION: (demandId) => `${OFFER_CHOICE_APPROVAL_BASE(demandId)}/sendDecision`,
    OFFER_CHOICE_APPROVAL_RESET: (demandId) => `${OFFER_CHOICE_APPROVAL_BASE(demandId)}/reset`,
    OFFER_CHOICE_APPROVAL_STOP: (demandId) => `${OFFER_CHOICE_APPROVAL_BASE(demandId)}/stop`,
    OFFER_CHOICE_APPROVAL_HISTORY_LIST: (demandId) => `${OFFER_CHOICE_APPROVAL_BASE(demandId)}/history`,
    OFFER_CHOICE_APPROVAL_HISTORY: (demandId, approvalId) => `${OFFER_CHOICE_APPROVAL_BASE(demandId)}/history/${approvalId}`,
    OFFER_CHOICE_APPROVAL_POSITIONS_LIST: (demandId) => `${OFFER_CHOICE_APPROVAL_BASE(demandId)}/positions`,
    OFFER_CHOICE_APPROVAL_HISTORY_GET_APPROVERS: (demandId, approvalId, stageId) => `${OFFER_CHOICE_APPROVAL_BASE(demandId)}/history/getAvailableApprovers/${approvalId}/${stageId}`,
    OFFER_CHOICE_APPROVAL_HISTORY_ADD_APPROVERS: (demandId, approvalId, stageId) => `${OFFER_CHOICE_APPROVAL_BASE(demandId)}/history/addApprovers/${approvalId}/${stageId}`,
    OFFER_CHOICE_APPROVAL_HISTORY_DELETE_APPROVER: (demandId, approvalId, stageId) => `${OFFER_CHOICE_APPROVAL_BASE(demandId)}/history/deleteApprover/${approvalId}/${stageId}`,
    OFFER_CHOICE_APPROVAL_VALIDATE: (demandId) => `${OFFER_CHOICE_APPROVAL_BASE(demandId)}/validate`
}

const ADDITIONAL_ROUND = (demandId) => `${DEMAND_BASE(demandId)}/evaluation/additionalRound`;
const additionalRound = {
    ADDITIONAL_ROUND_CHANGE_DATES: (demandId) => `${ADDITIONAL_ROUND(demandId)}/changeDates`
}

const DEMAND_ADDITIONAL_INFO = (demandId) => `${DEMAND_BASE(demandId)}/additionalInfo`;
const demandAdditionalInfo = {
    DEMAND_ADDITIONAL_INFO: DEMAND_ADDITIONAL_INFO,
    DEMAND_ADDITIONAL_INFO_VALIDATE: (id) => DEMAND_ADDITIONAL_INFO(id) + "/validate",
    DEMAND_ADDITIONAL_INFO_AUTOSAVE: (id) => `${DEMAND_ADDITIONAL_INFO(id)}/autoSave/${id}`,
    DEMAND_ADDITIONAL_INFO_AUTOSAVE_CHECK: (id) => `${DEMAND_ADDITIONAL_INFO(id)}/autoSave/${id}/check`
}

const AUCTION = (demandId) => `${DEMAND_BASE(demandId)}/auction`;
const AUCTION_RFX = (demandId, roundId) => `${AUCTION(demandId)}/${roundId}`;

const auction = {
    AUCTION_PREPARE: (demandId, roundId) => `${AUCTION_RFX(demandId, roundId)}/prepare`,
    AUCTION_CREATE: (demandId, roundId) => `${AUCTION_RFX(demandId, roundId)}/create`,
    AUCTION_EDIT_DATES: (demandId, roundId) => `${AUCTION_RFX(demandId, roundId)}/editDates`,
    AUCTION_PUBLISH: (demandId, roundId) => `${AUCTION_RFX(demandId, roundId)}/publish`,
    AUCTION_UNPUBLISH: (demandId, roundId) => `${AUCTION_RFX(demandId, roundId)}/unpublish`,
    AUCTION_PAUSE: (demandId, roundId) => `${AUCTION_RFX(demandId, roundId)}/pause`,
    AUCTION_RESUME: (demandId, roundId) => `${AUCTION_RFX(demandId, roundId)}/resume`,
    AUCTION_CANCEL: (demandId, roundId) => `${AUCTION_RFX(demandId, roundId)}/cancel`,
    AUCTION_DELETE: (demandId, roundId) => `${AUCTION_RFX(demandId, roundId)}/delete`,
    AUCTION_DOWNLOAD_INVITATION: (demandId, roundId) => `${AUCTION_RFX(demandId, roundId)}/auctionInvitation`,
    AUCTION_ACCEPT: (demandId, roundId, auctionId) => `${AUCTION_RFX(demandId, roundId)}/accept/${auctionId}`,
    AUCTION_DETAILS: (demandId, roundId, auctionId) => `${AUCTION_RFX(demandId, roundId)}/details/${auctionId}`,
}

const OFFER_CHOICE_RESULT = (demandId) => `${DEMAND_BASE(demandId)}/evaluation/result`;
const OFFER_CHOICE_RESULT_ID = (demandId, roundResultId) => `${OFFER_CHOICE_RESULT(demandId)}/${roundResultId}`;
const OFFER_CHOICE_RESULT_FILE = (demandId, roundResultId) => `${OFFER_CHOICE_RESULT_ID(demandId, roundResultId)}/file`;
const OFFER_CHOICE_RESULT_FILE_ID = (demandId, roundResultId, resultFileId) => `${OFFER_CHOICE_RESULT_FILE(demandId, roundResultId)}/${resultFileId}`;

const offerChoiceResult = {
    OFFER_CHOICE_RESULT: (demandId) => `${OFFER_CHOICE_RESULT(demandId)}`,
    OFFER_CHOICE_RESULT_GET: (demandId, roundResultId) => `${OFFER_CHOICE_RESULT_ID(demandId, roundResultId)}/get`,
    OFFER_CHOICE_RESULT_PRINT: (demandId, roundResultId) => `${OFFER_CHOICE_RESULT_ID(demandId, roundResultId)}/print`,
    OFFER_CHOICE_RESULT_SHARE: (demandId, roundResultId) => `${OFFER_CHOICE_RESULT_ID(demandId, roundResultId)}/share`,
    OFFER_CHOICE_RESULT_SHARE_HISTORY_LAST: (demandId, roundResultId) => `${OFFER_CHOICE_RESULT_ID(demandId, roundResultId)}/share/history/last`,
    OFFER_CHOICE_RESULT_SHARE_HISTORY: (demandId, roundResultId, system) => `${OFFER_CHOICE_RESULT_ID(demandId, roundResultId)}/share/history/${system}`,
    OFFER_CHOICE_RESULT_PUBLISH_UNTIL_DATE: (demandId, roundResultId) => `${OFFER_CHOICE_RESULT_ID(demandId, roundResultId)}/publishUntilDate`,
    OFFER_CHOICE_RESULT_FILE: (demandId, roundResultId) => OFFER_CHOICE_RESULT_FILE(demandId, roundResultId),
    OFFER_CHOICE_RESULT_FILE_PUBLISH: (demandId, roundResultId, resultFileId) => `${OFFER_CHOICE_RESULT_FILE_ID(demandId, roundResultId, resultFileId)}/publish`,
    OFFER_CHOICE_RESULT_FILE_UNPUBLISH: (demandId, roundResultId, resultFileId) => `${OFFER_CHOICE_RESULT_FILE_ID(demandId, roundResultId, resultFileId)}/unpublish`,
    OFFER_CHOICE_RESULT_FILE_DELETE: (demandId, roundResultId, resultFileId) => `${OFFER_CHOICE_RESULT_FILE_ID(demandId, roundResultId, resultFileId)}/delete`,
    OFFER_CHOICE_RESULT_FILE_DOWNLOAD_HISTORY: (demandId, roundResultId, resultFileId) => `${OFFER_CHOICE_RESULT_FILE_ID(demandId, roundResultId, resultFileId)}/history`,
    OFFER_CHOICE_RESULT_FILE_SHARE: (demandId, roundResultId, resultFileId) => `${OFFER_CHOICE_RESULT_FILE_ID(demandId, roundResultId, resultFileId)}/share`,
    OFFER_CHOICE_RESULT_FILE_SHARE_HISTORY_LAST: (demandId, roundResultId, resultFileId) => `${OFFER_CHOICE_RESULT_FILE_ID(demandId, roundResultId, resultFileId)}/share/history/last`,
    OFFER_CHOICE_RESULT_FILE_SHARE_HISTORY: (demandId, roundResultId, resultFileId, system) => `${OFFER_CHOICE_RESULT_FILE_ID(demandId, roundResultId, resultFileId)}/share/history/${system}`,
    OFFER_CHOICE_RESULT_FILE_DOWNLOAD_URL: (demandId, roundResultId, resultFileId, openInBrowser) => `${OFFER_CHOICE_RESULT_FILE_ID(demandId, roundResultId, resultFileId)}/url/${openInBrowser ? "open" : "download"}`,
    OFFER_CHOICE_RESULT_VALIDATE: (demandId) => `${OFFER_CHOICE_RESULT(demandId)}/validate`
}

const AGREEMENTS = (demandId) => `${DEMAND_BASE(demandId)}/evaluation/agreement`;

const agreements = {
    AGREEMENTS_AVAILABLE: (demandId) => `${AGREEMENTS(demandId)}/without`,
    AGREEMENTS_CREATED: (demandId) => `${AGREEMENTS(demandId)}/created`,
    AGREEMENTS_CREATE_NO_AGREEMENT: (demandId) => `${AGREEMENTS(demandId)}/createNoAgreement`,
    AGREEMENTS_CREATE_AGREEMENT: (demandId) => `${AGREEMENTS(demandId)}/createAgreement`,
    AGREEMENTS_AVAILABLE_ORGANIZATIONS: (demandId) => `${AGREEMENTS(demandId)}/organizations`,
    AGREEMENTS_DELETE: (demandId, objId) => `${AGREEMENTS(demandId)}/delete/extObj/${objId}`,
    AGREEMENTS_DELETE_AGR: (demandId, objId) => `${AGREEMENTS(demandId)}/delete/agreement/${objId}`,
    AGREEMENTS_VALIDATE: (demandId) => `${AGREEMENTS(demandId)}/validate`
}

const RESULT_NOTICE = (demandId) => `${DEMAND_BASE(demandId)}/resultNotice`;
const RESULT_NOTICE_ID = (demandId, resultNoticeId) => `${DEMAND_BASE(demandId)}/resultNotice/${resultNoticeId}`;
const RESULT_NOTICE_ATTACHMENT_ID = (demandId, resultNoticeId, resultNoticeAttachmentId) => `${RESULT_NOTICE_ID(demandId, resultNoticeId)}/file/${resultNoticeAttachmentId}`;

const resultNotice = {
    RESULT_NOTICE: (demandId) => `${RESULT_NOTICE(demandId)}`,
    RESULT_NOTICE_BZP: (demandId) => RESULT_NOTICE(demandId) + `/bzpNotice`,
    RESULT_NOTICE_PUBLISH_OJS_NOTICE: (demandId) => `${RESULT_NOTICE(demandId)}/publication/ojs/publish`,
    RESULT_NOTICE_CHECK_OJS_NOTICE: (demandId) => `${RESULT_NOTICE(demandId)}/publication/ojs/check`,
    RESULT_NOTICE_ROLLBACK_OJS_NOTICE: (demandId) => `${RESULT_NOTICE(demandId)}/publication/ojs/rollback`,
    RESULT_NOTICE_ID: (demandId, resultNoticeId) => `${RESULT_NOTICE_ID(demandId, resultNoticeId)}`,
    RESULT_NOTICE_VALIDATE: (demandId) => `${RESULT_NOTICE(demandId)}/validate`,
    RESULT_NOTICE_DELETE: (demandId, resultNoticeId, resultNoticeAttachmentId) => `${RESULT_NOTICE_ATTACHMENT_ID(demandId, resultNoticeId, resultNoticeAttachmentId)}/delete`,
    RESULT_NOTICE_PUBLISH: (demandId, resultNoticeId) => `${RESULT_NOTICE(demandId)}/publish/${resultNoticeId}`,
    RESULT_NOTICE_UNPUBLISH: (demandId, resultNoticeId) => `${RESULT_NOTICE(demandId)}/unpublish/${resultNoticeId}`,
    RESULT_NOTICE_ATTACHMENT_PUBLISH: (demandId, resultNoticeId, resultNoticeAttachmentId) => `${RESULT_NOTICE_ATTACHMENT_ID(demandId, resultNoticeId, resultNoticeAttachmentId)}/publish`,
    RESULT_NOTICE_ATTACHMENT_UNPUBLISH: (demandId, resultNoticeId, resultNoticeAttachmentId) => `${RESULT_NOTICE_ATTACHMENT_ID(demandId, resultNoticeId, resultNoticeAttachmentId)}/unpublish`,
    RESULT_NOTICE_DESCRIPTION: (demandId, resultNoticeId, resultNoticeAttachmentId) => `${RESULT_NOTICE_ATTACHMENT_ID(demandId, resultNoticeId, resultNoticeAttachmentId)}/description`,
    RESULT_NOTICE_REFERENCE_NUMBER: (demandId, resultNoticeId, resultNoticeAttachmentId) => `${RESULT_NOTICE_ATTACHMENT_ID(demandId, resultNoticeId, resultNoticeAttachmentId)}/noticeReferenceNumber`,
    RESULT_NOTICE_DOWNLOAD_FILE_URL: (demandId, resultNoticeId, resultNoticeAttachmentId, openInBrowser) =>
        `${RESULT_NOTICE_ATTACHMENT_ID(demandId, resultNoticeId, resultNoticeAttachmentId)}/url/${openInBrowser ? "open" : "download"}`,
    RESULT_NOTICE_DOWNLOAD_FILE_HISTORY: (demandId, resultNoticeId, resultNoticeAttachmentId) =>
        `${RESULT_NOTICE_ATTACHMENT_ID(demandId, resultNoticeId, resultNoticeAttachmentId)}/downloadHistory`
}

const EVALUATION_FINISH = (demandId) => `${DEMAND_BASE(demandId)}/evaluation/finish`;
const evaluationFinish = {
    EVALUATION_FINISH: (demandId) => `${EVALUATION_FINISH(demandId)}`
}

const DEMAND_PLAN_REALIZATION = (demandId) => `${DEMAND_BASE(demandId)}/planRealization`;
const demandPlanRealization = {
    DEMAND_PLAN_REALIZATION: (demandId) => `${DEMAND_PLAN_REALIZATION(demandId)}`,
    DEMAND_PLAN_REALIZATION_VALIDATE: (demandId) => `${DEMAND_PLAN_REALIZATION(demandId)}/validate`
}

const FINISH_DEMAND = (demandId) => `${DEMAND_BASE(demandId)}/finish`;
const finishDemand = {
    FINISH_DEMAND: (demandId) => `${FINISH_DEMAND(demandId)}`,
    FINISH_DEMAND_BACK_TO_OFFER_EVALUATION: (demandId) => `${FINISH_DEMAND(demandId)}/backToOfferEvaluation`,
    FINISH_DEMAND_BACK_TO_RESULT_NOTICE: (demandId) => `${FINISH_DEMAND(demandId)}/backToResultNotice`,
    FINISH_DEMAND_WITHDRAWAL_NOTICE_DATE: (demandId) => `${FINISH_DEMAND(demandId)}/withdrawalNoticeDate`,
    FINISH_DEMAND_CANCEL: (demandId) => `${FINISH_DEMAND(demandId)}/cancelDemand`,
    FINISH_DEMAND_FINISH: (demandId) => `${FINISH_DEMAND(demandId)}/finishDemand`,
    FINISH_DEMAND_VALIDATE: (demandId) => `${FINISH_DEMAND(demandId)}/validate`
}

const ARCHIVING = (demandId) => `${DEMAND_BASE(demandId)}/archiving`;
const archiving = {
    ARCHIVING: (demandId) => `${ARCHIVING(demandId)}`,
    ARCHIVING_SHARE_HISTORY_LAST: (demandId) => `${ARCHIVING(demandId)}/share/history/last`,
    ARCHIVING_SHARE_HISTORY: (demandId, system) => `${ARCHIVING(demandId)}/share/history/${system}`,
    ARCHIVING_SCHEDULE: (demandId) => `${ARCHIVING(demandId)}/scheduleArchive`,
    ARCHIVING_VALIDATE: (demandId) => `${ARCHIVING(demandId)}/validate`
}

const ADDITIONAL_ROUNDS_PASSIVE = (demandId) => `${DEMAND_BASE(demandId)}/additionalRoundPassive`;
const additionalRoundsPassive = {
    ADDITIONAL_ROUNDS_PASSIVE: (demandId) => `${ADDITIONAL_ROUNDS_PASSIVE(demandId)}`,
    ADDITIONAL_ROUNDS_PASSIVE_ROUND: (demandId, roundId) => `${ADDITIONAL_ROUNDS_PASSIVE(demandId)}/round/${roundId}`,
    ADDITIONAL_ROUNDS_PASSIVE_AVAILABLE_CONTRACTORS: (demandId) => `${ADDITIONAL_ROUNDS_PASSIVE(demandId)}/availableContractors`,
    ADDITIONAL_ROUNDS_PASSIVE_VALIDATE: (demandId) => `${ADDITIONAL_ROUNDS_PASSIVE(demandId)}/validate`
}

const CORRESPONDENCE_BASE = `${base.RFX}/correspondence`;

const CORRESPONDENCE_BUYER_BASE = (roundId) => `${CORRESPONDENCE_BASE}/buyer/${roundId}`;

const correspondenceBuyer = {
    CORRESPONDENCE_BUYER_CTR_IN_ROUND: (roundId) => `${CORRESPONDENCE_BUYER_BASE(roundId)}/getContractorsInRound`,
    CORRESPONDENCE_BUYER_THREAD_LIST: (roundId) => `${CORRESPONDENCE_BUYER_BASE(roundId)}/thread/list`,
    CORRESPONDENCE_BUYER_NEW_MESSAGES: (roundId) => `${CORRESPONDENCE_BUYER_BASE(roundId)}/newMessages`,
    CORRESPONDENCE_BUYER_SEARCH: (roundId) => `${CORRESPONDENCE_BUYER_BASE(roundId)}/search`,

    CORRESPONDENCE_BUYER_THREAD_ADD: (roundId) => `${CORRESPONDENCE_BUYER_BASE(roundId)}/thread/add`,
    CORRESPONDENCE_BUYER_THREAD_AS_CRT_SEND: (roundId) => `${CORRESPONDENCE_BUYER_BASE(roundId)}/asContractor/thread/send`,
    CORRESPONDENCE_BUYER_BULK_MESSAGES_SEND: (roundId) => `${CORRESPONDENCE_BUYER_BASE(roundId)}/bulk/message/send`,
    CORRESPONDENCE_BUYER_BULK_MESSAGES_PUBLISH: (roundId) => `${CORRESPONDENCE_BUYER_BASE(roundId)}/bulk/message/publish`,
    CORRESPONDENCE_BUYER_PRIVILEGES: (roundId) => `${CORRESPONDENCE_BUYER_BASE(roundId)}/privileges`,
    CORRESPONDENCE_BUYER_PRINT: (roundId, type, before) => `${CORRESPONDENCE_BUYER_BASE(roundId)}/${type}/${before === true ? "before" : (before === false ? "after" : "all")}/print`,
    CORRESPONDENCE_BUYER_SHARE: (roundId, type, before) => `${CORRESPONDENCE_BUYER_BASE(roundId)}/${type}/${before === true ? "before" : (before === false ? "after" : "all")}/share`,
    CORRESPONDENCE_BUYER_SHARE_HISTORY_LAST: (roundId, before) => `${CORRESPONDENCE_BUYER_BASE(roundId)}/${before === true ? "before" : (before === false ? "after" : "all")}/share/history/last`,
    CORRESPONDENCE_BUYER_SHARE_HISTORY: (roundId, before, system) => `${CORRESPONDENCE_BUYER_BASE(roundId)}/${before === true ? "before" : (before === false ? "after" : "all")}/share/history/${system}`,
    CORRESPONDENCE_BUYER_HAS_UNSENT_MESSAGES: (roundId, before) => `${CORRESPONDENCE_BUYER_BASE(roundId)}/${before === true ? "before" : (before === false ? "after" : "all")}/hasUnsentMessages`,

    CORRESPONDENCE_BUYER_MESSAGE_LIST: (roundId, threadId) => `${CORRESPONDENCE_BUYER_BASE(roundId)}/thread/${threadId}/message/list`,
    CORRESPONDENCE_BUYER_MESSAGE_CREATE: (roundId, threadId) => `${CORRESPONDENCE_BUYER_BASE(roundId)}/thread/${threadId}/message/create`,
    CORRESPONDENCE_BUYER_MESSAGE_MARK_AS_READ: (roundId) => `${CORRESPONDENCE_BUYER_BASE(roundId)}/messages/markAsRead`,
    CORRESPONDENCE_BUYER_FLAG: (roundId, threadId) => `${CORRESPONDENCE_BUYER_BASE(roundId)}/thread/${threadId}/flag`,
    CORRESPONDENCE_BUYER_UNFLAG: (roundId, threadId) => `${CORRESPONDENCE_BUYER_BASE(roundId)}/thread/${threadId}/unflag`,
    CORRESPONDENCE_BUYER_THREAD_EMAIL_LIST: (roundId, threadId) => `${CORRESPONDENCE_BUYER_BASE(roundId)}/thread/${threadId}/emailList`,

    CORRESPONDENCE_BUYER_MESSAGE_SEND: (roundId, messageId) => `${CORRESPONDENCE_BUYER_BASE(roundId)}/message/${messageId}/send`,
    CORRESPONDENCE_BUYER_MESSAGE_PUBLISH: (roundId, messageId) => `${CORRESPONDENCE_BUYER_BASE(roundId)}/message/${messageId}/publish`,
    CORRESPONDENCE_BUYER_MESSAGE_UPDATE: (roundId, messageId) => `${CORRESPONDENCE_BUYER_BASE(roundId)}/message/${messageId}/update`,
    CORRESPONDENCE_BUYER_MESSAGE_DELETE: (roundId, messageId) => `${CORRESPONDENCE_BUYER_BASE(roundId)}/message/${messageId}/delete`,

    CORRESPONDENCE_BUYER_ATTACHMENT_URL: (roundId, attachmentId) => `${CORRESPONDENCE_BUYER_BASE(roundId)}/attachment/${attachmentId}/url`,

    CORRESPONDENCE_BUYER_MESSAGE_EMAIL_DELIVERY: (roundId, messageId, type, identity) => `${CORRESPONDENCE_BUYER_BASE(roundId)}/message/${messageId}/emailDelivery/${type}/${identity}`,
    CORRESPONDENCE_BUYER_MESSAGE_ATTACHMENTS_ZIP: (roundId, messageId) => `${CORRESPONDENCE_BUYER_BASE(roundId)}/message/${messageId}/attachments`,
    CORRESPONDENCE_BUYER_MESSAGE_ATTACHMENTS_CHECK_LIMIT: (roundId, messageId) => `${CORRESPONDENCE_BUYER_BASE(roundId)}/message/${messageId}/attachments/checkVerificationLimit`,
    CORRESPONDENCE_BUYER_MESSAGE_ATTACHMENTS_VERIFY: (roundId, messageId) => `${CORRESPONDENCE_BUYER_BASE(roundId)}/message/${messageId}/attachments/printVerification`,
    CORRESPONDENCE_BUYER_CONTRACTOR_EMAIL_LIST: (roundId, departmentId) => `${CORRESPONDENCE_BUYER_BASE(roundId)}/contractor/${departmentId}/emailList`,
}

const CORRESPONDENCE_CONTRACTOR_BASE = (roundId) => `${CORRESPONDENCE_BASE}/contractor/${roundId}`;

const correspondenceContractor = {
    CORRESPONDENCE_CONTRACTOR_THREAD_LIST: (roundId) => `${CORRESPONDENCE_CONTRACTOR_BASE(roundId)}/thread/list`,
    CORRESPONDENCE_CONTRACTOR_NEW_MESSAGES: (roundId) => `${CORRESPONDENCE_CONTRACTOR_BASE(roundId)}/newMessages`,
    CORRESPONDENCE_CONTRACTOR_SEARCH: (roundId) => `${CORRESPONDENCE_CONTRACTOR_BASE(roundId)}/search`,

    CORRESPONDENCE_CONTRACTOR_THREAD_ADD: (roundId) => `${CORRESPONDENCE_CONTRACTOR_BASE(roundId)}/thread/add`,
    CORRESPONDENCE_CONTRACTOR_PRIVILEGES: (roundId) => `${CORRESPONDENCE_CONTRACTOR_BASE(roundId)}/privileges`,
    CORRESPONDENCE_CONTRACTOR_PRINT: (roundId, type, before) => `${CORRESPONDENCE_CONTRACTOR_BASE(roundId)}/${type}/${before === true ? "before" : (before === false ? "after" : "all")}/print`,
    CORRESPONDENCE_CONTRACTOR_HAS_UNSENT_MESSAGES: (roundId, before) => `${CORRESPONDENCE_CONTRACTOR_BASE(roundId)}/${before === true ? "before" : (before === false ? "after" : "all")}/hasUnsentMessages`,

    CORRESPONDENCE_CONTRACTOR_MESSAGE_LIST: (roundId, threadId) => `${CORRESPONDENCE_CONTRACTOR_BASE(roundId)}/thread/${threadId}/message/list`,
    CORRESPONDENCE_CONTRACTOR_MESSAGE_CREATE: (roundId, threadId) => `${CORRESPONDENCE_CONTRACTOR_BASE(roundId)}/thread/${threadId}/message/create`,
    CORRESPONDENCE_CONTRACTOR_MESSAGE_MARK_AS_READ: (roundId) => `${CORRESPONDENCE_CONTRACTOR_BASE(roundId)}/messages/markAsRead`,
    CORRESPONDENCE_CONTRACTOR_FLAG: (roundId, threadId) => `${CORRESPONDENCE_CONTRACTOR_BASE(roundId)}/thread/${threadId}/flag`,
    CORRESPONDENCE_CONTRACTOR_UNFLAG: (roundId, threadId) => `${CORRESPONDENCE_CONTRACTOR_BASE(roundId)}/thread/${threadId}/unflag`,

    CORRESPONDENCE_CONTRACTOR_MESSAGE_UPDATE: (roundId, messageId) => `${CORRESPONDENCE_CONTRACTOR_BASE(roundId)}/message/${messageId}/update`,
    CORRESPONDENCE_CONTRACTOR_MESSAGE_SEND: (roundId, messageId) => `${CORRESPONDENCE_CONTRACTOR_BASE(roundId)}/message/${messageId}/send`,
    CORRESPONDENCE_CONTRACTOR_MESSAGE_DELETE: (roundId, messageId) => `${CORRESPONDENCE_CONTRACTOR_BASE(roundId)}/message/${messageId}/delete`,

    CORRESPONDENCE_CONTRACTOR_ATTACHMENT_URL: (roundId, attachmentId) => `${CORRESPONDENCE_CONTRACTOR_BASE(roundId)}/attachment/${attachmentId}/url`,

    CORRESPONDENCE_CONTRACTOR_MESSAGE_ATTACHMENTS_ZIP: (roundId, messageId) => `${CORRESPONDENCE_CONTRACTOR_BASE(roundId)}/message/${messageId}/attachments`,
}

const DEMAND_OFFERS_BASE = (id) => `${DEMAND_BASE(id)}/offers`
const DEMAND_OFFERS_STAGE_BASE = (id, stageId) => `${DEMAND_OFFERS_BASE(id)}/${stageId}`

const demandOffers = {
    DEMAND_OFFERS_CONTRACTOR_STAGES_LIST: (id, contractorDepartmentId) => `${DEMAND_OFFERS_BASE(id)}/stages/${contractorDepartmentId ? 'operator' : 'contractor'}`,
    DEMAND_OFFERS_CONTRACTOR_STAGE_SECTIONS_LIST: (id, stageId, supplierId) => `${DEMAND_OFFERS_STAGE_BASE(id, stageId)}/sections/${supplierId ? 'operator' : 'contractor'}`,
    DEMAND_OFFERS_CONTRACTOR_STAGE_TRANSLATIONS: (id, stageId, supplierId) => `${DEMAND_OFFERS_STAGE_BASE(id, stageId)}/translations/${supplierId ? 'operator' : 'contractor'}`,
    DEMAND_OFFERS_CONTRACTOR_STAGE_SECTION: (id, stageId, section, supplierId) => `${DEMAND_OFFERS_STAGE_BASE(id, stageId)}/sections/${section}/${supplierId ? 'operator' : 'contractor'}`,
    DEMAND_OFFERS_STAGE_CURRENT_ROUND: (id, stageId) => `${DEMAND_OFFERS_STAGE_BASE(id, stageId)}/currentRound`,
    DEMAND_OFFERS_CONTRACTOR_STAGE_PASSWORD: (id, stageId) => `${DEMAND_OFFERS_STAGE_BASE(id, stageId)}/password`,
    DEMAND_OFFERS_VALIDATE: (demandId) => `${DEMAND_OFFERS_BASE(demandId)}/validate`
}

const DEMAND_OFFERS_STAGE_CONTRACTOR_GENERAL_INFO_BASE = (id, stageId, supplierId) => `${DEMAND_OFFERS_STAGE_BASE(id, stageId)}/${supplierId ? "operator" : "contractor"}/generalInfo`
const demandOffersGeneralInfo = {
    DEMAND_OFFERS_CONTRACTOR_GENERAL_INFO_BASIC_DATA: (id, stageId, supplierId) => `${DEMAND_OFFERS_STAGE_CONTRACTOR_GENERAL_INFO_BASE(id, stageId, supplierId)}/basicData`,
    DEMAND_OFFERS_CONTRACTOR_GENERAL_INFO_DOCUMENTS: (id, stageId, supplierId) => `${DEMAND_OFFERS_STAGE_CONTRACTOR_GENERAL_INFO_BASE(id, stageId, supplierId)}/documents`,
    DEMAND_OFFERS_CONTRACTOR_GENERAL_INFO_DOCUMENTS_DOWNLOAD_URL: (id, stageId, type, documentId, supplierId) => `${DEMAND_OFFERS_STAGE_CONTRACTOR_GENERAL_INFO_BASE(id, stageId, supplierId)}/documents/downloadUrl/${type}/${documentId}`,
    DEMAND_OFFERS_CONTRACTOR_GENERAL_INFO_DOCUMENTS_DOWNLOAD_ZIP: (id, stageId, supplierId) => `${DEMAND_OFFERS_STAGE_CONTRACTOR_GENERAL_INFO_BASE(id, stageId, supplierId)}/documents/download/zip`,
    DEMAND_OFFERS_CONTRACTOR_GENERAL_INFO_PUBLIC_ANSWERS: (id, stageId, supplierId) => `${DEMAND_OFFERS_STAGE_CONTRACTOR_GENERAL_INFO_BASE(id, stageId, supplierId)}/publicAnswers`,
}

const DEMAND_OFFERS_STAGE_OFFER_BASE = (id, stageId, supplierId) => `${DEMAND_OFFERS_STAGE_BASE(id, stageId)}/${supplierId ? 'operator' : 'contractor'}/offer`;

const demandOffersOffer = {
    DEMAND_OFFERS_STAGE_CONTRACTOR_OFFER: (demandId, stageId, supplierId) => DEMAND_OFFERS_STAGE_OFFER_BASE(demandId, stageId, supplierId),
    DEMAND_OFFERS_OFFER_MODE: (id, stage, supplierId, mode) => `${DEMAND_OFFERS_STAGE_OFFER_BASE(id, stage, supplierId)}/${mode}`,
    DEMAND_OFFERS_OFFER_MODE_POSITIONS: (id, stage, mode, supplierId) => `${DEMAND_OFFERS_STAGE_OFFER_BASE(id, stage, supplierId)}/${mode}/positions`,
    DEMAND_OFFERS_OFFER_MODE_FILES: (id, stage, mode, supplierId) => `${DEMAND_OFFERS_STAGE_OFFER_BASE(id, stage, supplierId)}/${mode}/files`,
    DEMAND_OFFERS_OFFER_MODE_TEMPLATE: (id, stage, mode, supplierId) => `${DEMAND_OFFERS_STAGE_OFFER_BASE(id, stage, supplierId)}/${mode}/template`,
    DEMAND_OFFERS_OFFER_MODE_FILE_DOWNLOAD_URL: (id, stage, mode, fileId, supplierId) => `${DEMAND_OFFERS_STAGE_OFFER_BASE(id, stage, supplierId)}/${mode}/file/${fileId}`,
    DEMAND_OFFERS_OFFER_MODE_FILE_DOWNLOAD_ZIP: (id, stage, supplierId) => `${DEMAND_OFFERS_STAGE_OFFER_BASE(id, stage, supplierId)}/documents/download/zip`,
    DEMAND_OFFERS_OFFER_FILE: (id, stage, supplierId) => `${DEMAND_OFFERS_STAGE_OFFER_BASE(id, stage, supplierId)}/file`,
    DEMAND_OFFERS_OFFER_FILES: (id, stage, supplierId) => `${DEMAND_OFFERS_STAGE_OFFER_BASE(id, stage, supplierId)}/files`,
    DEMAND_OFFERS_OFFER_FILE_ID: (id, stage, fileId, supplierId) => `${DEMAND_OFFERS_STAGE_OFFER_BASE(id, stage, supplierId)}/file/${fileId}`,
    DEMAND_OFFERS_OFFER_FILE_ID_SIGN_FILE: (id, stage, fileId, supplierId) => `${DEMAND_OFFERS_STAGE_OFFER_BASE(id, stage, supplierId)}/file/${fileId}/signFile`,

    DEMAND_OFFERS_OFFER_ESPD: (id, stage, supplierId) => `${DEMAND_OFFERS_STAGE_OFFER_BASE(id, stage, supplierId)}/espd`,
    DEMAND_OFFERS_OFFER_ESPDS: (id, stage, supplierId) => `${DEMAND_OFFERS_STAGE_OFFER_BASE(id, stage, supplierId)}/espds`,
    DEMAND_OFFERS_OFFER_ESPD_ID: (id, stage, espdId, supplierId) => `${DEMAND_OFFERS_STAGE_OFFER_BASE(id, stage, supplierId)}/espd/${espdId}`,
    DEMAND_OFFERS_OFFER_ESPD_ID_SIGN_FILE: (id, stage, espdId, supplierId) => `${DEMAND_OFFERS_STAGE_OFFER_BASE(id, stage, supplierId)}/espd/${espdId}/signFile`,
    DEMAND_OFFERS_OFFER_ESPD_MP_APP_URL: (id, stage) => `${DEMAND_OFFERS_STAGE_OFFER_BASE(id, stage)}/espd/mpAppUrl`,
    DEMAND_OFFERS_OFFER_ESPD_EXPORT_FILE_URL: (id, stage) => `${DEMAND_OFFERS_STAGE_OFFER_BASE(id, stage)}/espd/exportFileUrl`,
    DEMAND_OFFERS_OFFER_MODE_ESPD_DOWNLOAD_URL: (id, stage, mode, espdId, supplierId) => `${DEMAND_OFFERS_STAGE_OFFER_BASE(id, stage, supplierId)}/${mode}/espd/${espdId}`,

    DEMAND_OFFERS_OFFER_PLACE_OFFER: (id, stage, supplierId) => `${DEMAND_OFFERS_STAGE_OFFER_BASE(id, stage, supplierId)}/placeOffer`,
    DEMAND_OFFERS_OFFER_WITHDRAW_OFFER: (id, stage) => `${DEMAND_OFFERS_STAGE_OFFER_BASE(id, stage)}/withdrawOffer`,
    DEMAND_OFFERS_OFFER_SIGN_OFFER: (id, stage) => `${DEMAND_OFFERS_STAGE_OFFER_BASE(id, stage)}/signOffer`,
    DEMAND_OFFERS_OFFER_SIGN_WITHDRAW: (id, stage) => `${DEMAND_OFFERS_STAGE_OFFER_BASE(id, stage)}/signWithdraw`,
    DEMAND_OFFERS_OFFER_DOC_TO_SIGN: (id, stage) => `${DEMAND_OFFERS_STAGE_OFFER_BASE(id, stage)}/offerDocumentToSign`,
    DEMAND_OFFERS_OFFER_WITHDRAW_DOC_TO_SIGN: (id, stage) => `${DEMAND_OFFERS_STAGE_OFFER_BASE(id, stage)}/withdrawDocumentToSign`,
    DEMAND_OFFERS_OFFER_STOP_SIGNING_OPERATION: (id, stage) => `${DEMAND_OFFERS_STAGE_OFFER_BASE(id, stage)}/stopSigningOperation`,
    DEMAND_OFFERS_OFFER_REQUIRE_WITHDRAW_ENCRYPTION: (id, stage) => `${DEMAND_OFFERS_STAGE_OFFER_BASE(id, stage)}/requireWithdrawEncryption`,
    DEMAND_OFFERS_OFFER_DELETE_OFFER: (id, stage) => `${DEMAND_OFFERS_STAGE_OFFER_BASE(id, stage)}/deleteOffer`,

    DEMAND_OFFERS_OFFER_POSITION: (id, stage, supplierId) => `${DEMAND_OFFERS_STAGE_OFFER_BASE(id, stage, supplierId)}/position`,
    DEMAND_OFFERS_OFFER_MODE_POSITION_ID: (id, stage, mode, positionId, supplierId) => `${DEMAND_OFFERS_STAGE_OFFER_BASE(id, stage, supplierId)}/${mode}/position/${positionId}`,

    DEMAND_OFFERS_OFFER_SNAPSHOTS: (id, stage, supplierId) => `${DEMAND_OFFERS_STAGE_OFFER_BASE(id, stage, supplierId)}/snapshots`,
    DEMAND_OFFERS_OFFER_SNAPSHOT_ID: (id, stage, snapshotId, supplierId) => `${DEMAND_OFFERS_STAGE_OFFER_BASE(id, stage, supplierId)}/snapshot/${snapshotId}`,
    DEMAND_OFFERS_OFFER_VERIFICATIONS: (id, stage, supplierId) => `${DEMAND_OFFERS_STAGE_OFFER_BASE(id, stage, supplierId)}/verifications`,
    DEMAND_OFFERS_OFFER_VERIFICATION_BEFORE_PLACE: (id, stage, supplierId) => `${DEMAND_OFFERS_STAGE_OFFER_BASE(id, stage, supplierId)}/verificationBeforePlaceOffer`,

}

const DEMAND_ADDITIONAL_OFFERS_STAGE_OFFER_BASE = (id, stageId, supplierId) => `${DEMAND_OFFERS_STAGE_BASE(id, stageId)}/${supplierId ? 'operator' : 'contractor'}/additionalOffers`;

const demandAdditionalOffersOffer = {
    DEMAND_ADDITIONAL_OFFERS_OFFER_MODE: (id, stage, mode, supplierId) => `${DEMAND_ADDITIONAL_OFFERS_STAGE_OFFER_BASE(id, stage, supplierId)}/${mode}`,
    DEMAND_ADDITIONAL_OFFERS_OFFER_MODE_POSITIONS: (id, stage, mode, supplierId) => `${DEMAND_ADDITIONAL_OFFERS_STAGE_OFFER_BASE(id, stage, supplierId)}/${mode}/positions`,
    DEMAND_ADDITIONAL_OFFERS_OFFER_MODE_FILES: (id, stage, mode, supplierId) => `${DEMAND_ADDITIONAL_OFFERS_STAGE_OFFER_BASE(id, stage, supplierId)}/${mode}/files`,
    DEMAND_ADDITIONAL_OFFERS_OFFER_MODE_FILE_DOWNLOAD_URL: (id, stage, mode, fileId, supplierId) => `${DEMAND_ADDITIONAL_OFFERS_STAGE_OFFER_BASE(id, stage, supplierId)}/${mode}/file/${fileId}`,
    DEMAND_ADDITIONAL_OFFERS_OFFER_MODE_FILE_DOWNLOAD_ZIP: (id, stage, mode, fileId, supplierId) => `${DEMAND_ADDITIONAL_OFFERS_STAGE_OFFER_BASE(id, stage, supplierId)}/documents/download/zip`,
    DEMAND_ADDITIONAL_OFFERS_OFFER_FILE: (id, stage, supplierId) => `${DEMAND_ADDITIONAL_OFFERS_STAGE_OFFER_BASE(id, stage, supplierId)}/file`,
    DEMAND_ADDITIONAL_OFFERS_OFFER_FILES: (id, stage, supplierId) => `${DEMAND_ADDITIONAL_OFFERS_STAGE_OFFER_BASE(id, stage, supplierId)}/files`,
    DEMAND_ADDITIONAL_OFFERS_OFFER_FILE_ID: (id, stage, fileId, supplierId) => `${DEMAND_ADDITIONAL_OFFERS_STAGE_OFFER_BASE(id, stage, supplierId)}/file/${fileId}`,
    DEMAND_ADDITIONAL_OFFERS_OFFER_FILE_ID_SIGN_FILE: (id, stage, fileId, supplierId) => `${DEMAND_ADDITIONAL_OFFERS_STAGE_OFFER_BASE(id, stage, supplierId)}/file/${fileId}/signFile`,

    DEMAND_ADDITIONAL_OFFERS_OFFER_MODE_ESPD_DOWNLOAD_URL: (id, stage, mode, espdId, supplierId) => `${DEMAND_ADDITIONAL_OFFERS_STAGE_OFFER_BASE(id, stage, supplierId)}/${mode}/espd/${espdId}`,

    DEMAND_ADDITIONAL_OFFERS_OFFER_PLACE_OFFER: (id, stage, supplierId) => `${DEMAND_ADDITIONAL_OFFERS_STAGE_OFFER_BASE(id, stage, supplierId)}/placeOffer`,
    DEMAND_ADDITIONAL_OFFERS_OFFER_WITHDRAW_OFFER: (id, stage) => `${DEMAND_ADDITIONAL_OFFERS_STAGE_OFFER_BASE(id, stage)}/withdrawOffer`,
    DEMAND_ADDITIONAL_OFFERS_OFFER_SIGN_OFFER: (id, stage) => `${DEMAND_ADDITIONAL_OFFERS_STAGE_OFFER_BASE(id, stage)}/signOffer`,
    DEMAND_ADDITIONAL_OFFERS_OFFER_SIGN_WITHDRAW: (id, stage) => `${DEMAND_ADDITIONAL_OFFERS_STAGE_OFFER_BASE(id, stage)}/signWithdraw`,
    DEMAND_ADDITIONAL_OFFERS_OFFER_DOC_TO_SIGN: (id, stage) => `${DEMAND_ADDITIONAL_OFFERS_STAGE_OFFER_BASE(id, stage)}/offerDocumentToSign`,
    DEMAND_ADDITIONAL_OFFERS_OFFER_WITHDRAW_DOC_TO_SIGN: (id, stage) => `${DEMAND_ADDITIONAL_OFFERS_STAGE_OFFER_BASE(id, stage)}/withdrawDocumentToSign`,
    DEMAND_ADDITIONAL_OFFERS_OFFER_STOP_SIGNING_OPERATION: (id, stage, positionId) => `${DEMAND_ADDITIONAL_OFFERS_STAGE_OFFER_BASE(id, stage)}/stopSigningOperation/${positionId}`,
    DEMAND_ADDITIONAL_OFFERS_OFFER_REQUIRE_WITHDRAW_ENCRYPTION: (id, stage) => `${DEMAND_ADDITIONAL_OFFERS_STAGE_OFFER_BASE(id, stage)}/requireWithdrawEncryption`,
    DEMAND_ADDITIONAL_OFFERS_OFFER_DELETE_OFFER: (id, stage) => `${DEMAND_ADDITIONAL_OFFERS_STAGE_OFFER_BASE(id, stage)}/deleteOffer`,

    DEMAND_ADDITIONAL_OFFERS_OFFER_POSITION: (id, stage, supplierId) => `${DEMAND_ADDITIONAL_OFFERS_STAGE_OFFER_BASE(id, stage, supplierId)}/position`,
    DEMAND_ADDITIONAL_OFFERS_OFFER_MODE_POSITION_ID: (id, stage, mode, positionId, supplierId) => `${DEMAND_ADDITIONAL_OFFERS_STAGE_OFFER_BASE(id, stage, supplierId)}/${mode}/position/${positionId}`,
    DEMAND_ADDITIONAL_OFFERS_OFFER_SNAPSHOTS: (id, stage, positionId, supplierId) => `${DEMAND_ADDITIONAL_OFFERS_STAGE_OFFER_BASE(id, stage, supplierId)}/snapshots/${positionId}`,
    DEMAND_ADDITIONAL_OFFERS_OFFER_SNAPSHOT_ID: (id, stage, positionId, snapshotId, supplierId) => `${DEMAND_ADDITIONAL_OFFERS_STAGE_OFFER_BASE(id, stage, supplierId)}/snapshot/${positionId}/${snapshotId}`,
    DEMAND_ADDITIONAL_OFFERS_OFFER_VERIFICATIONS: (id, stage, positionId, supplierId) => `${DEMAND_ADDITIONAL_OFFERS_STAGE_OFFER_BASE(id, stage, supplierId)}/verifications/${positionId}`,
    DEMAND_ADDITIONAL_OFFERS_OFFER_VERIFICATION_BEFORE_PLACE: (id, stage, supplierId) => `${DEMAND_ADDITIONAL_OFFERS_STAGE_OFFER_BASE(id, stage, supplierId)}/verificationBeforePlaceOffer`,
}

const DEMAND_ADDITIONAL_AUCTIONS_STAGE_OFFER_BASE = (id, stageId, supplierId) => `${DEMAND_OFFERS_STAGE_BASE(id, stageId)}/${supplierId ? 'operator' : 'contractor'}/additionalAuction`;

const demandAdditionalAuction = {
    DEMAND_ADDITIONAL_AUCTIONS_OFFER_AUCTIONS: (id, stage) => `${DEMAND_ADDITIONAL_AUCTIONS_STAGE_OFFER_BASE(id, stage)}/auctions`,
    DEMAND_ADDITIONAL_AUCTIONS_OFFER_AUCTIONS_ASSIGN: (id, stage, auctionId) => `${DEMAND_ADDITIONAL_AUCTIONS_STAGE_OFFER_BASE(id, stage)}/${auctionId}/assignToAuction`,

    DEMAND_ADDITIONAL_AUCTIONS_OFFER_MODE: (id, stage, mode, supplierId) => `${DEMAND_ADDITIONAL_AUCTIONS_STAGE_OFFER_BASE(id, stage, supplierId)}/${mode}`,
    DEMAND_ADDITIONAL_AUCTIONS_OFFER_MODE_ESPD_DOWNLOAD_URL: (id, stage, mode, espdId, supplierId) => `${DEMAND_ADDITIONAL_AUCTIONS_STAGE_OFFER_BASE(id, stage, supplierId)}/${mode}/espd/${espdId}`,
    DEMAND_ADDITIONAL_AUCTIONS_OFFER_MODE_FILE_DOWNLOAD_URL: (id, stage, mode, fileId, supplierId) => `${DEMAND_ADDITIONAL_AUCTIONS_STAGE_OFFER_BASE(id, stage, supplierId)}/${mode}/file/${fileId}`,
    DEMAND_ADDITIONAL_AUCTIONS_OFFER_MODE_FILES: (id, stage, mode, supplierId) => `${DEMAND_ADDITIONAL_AUCTIONS_STAGE_OFFER_BASE(id, stage, supplierId)}/${mode}/files`,
    DEMAND_ADDITIONAL_AUCTIONS_OFFER_POSITION: (id, stage, supplierId) => `${DEMAND_ADDITIONAL_AUCTIONS_STAGE_OFFER_BASE(id, stage, supplierId)}/position`,
    DEMAND_ADDITIONAL_AUCTIONS_OFFER_MODE_POSITION_ID: (id, stage, mode, positionId, supplierId) => `${DEMAND_ADDITIONAL_AUCTIONS_STAGE_OFFER_BASE(id, stage, supplierId)}/${mode}/position/${positionId}`,
    DEMAND_ADDITIONAL_AUCTIONS_OFFER_SNAPSHOTS: (id, stage, positionId, supplierId) => `${DEMAND_ADDITIONAL_AUCTIONS_STAGE_OFFER_BASE(id, stage, supplierId)}/snapshots/${positionId}`,
    DEMAND_ADDITIONAL_AUCTIONS_OFFER_SNAPSHOT_ID: (id, stage, positionId, snapshotId, supplierId) => `${DEMAND_ADDITIONAL_AUCTIONS_STAGE_OFFER_BASE(id, stage, supplierId)}/snapshot/${positionId}/${snapshotId}`,
}

const demandOffersAccess = {
    DEMAND_OFFERS_ACCESS_USERS: (id, stageId) => `${DEMAND_OFFERS_STAGE_BASE(id, stageId)}/accessUsers`,
    DEMAND_OFFERS_ACCESS_ADMIN: (id, stageId) => `${DEMAND_OFFERS_STAGE_BASE(id, stageId)}/accessAdmin`,
    DEMAND_OFFERS_ACCESS_HISTORY: (id, stageId) => `${DEMAND_OFFERS_STAGE_BASE(id, stageId)}/accessUsers/history`
}


const DEMAND_PREVIEW_STAGE_OFFER_BASE = (id, stageId, supplierId) => `${DEMAND_OFFERS_STAGE_BASE(id, stageId)}/${supplierId ? 'operator' : 'contractor'}/preview`;
const demandPublicationPreview = {
    DEMAND_PREVIEW_OFFER_MODE: (id, stage, supplierId, mode) => `${DEMAND_PREVIEW_STAGE_OFFER_BASE(id, stage, supplierId)}/${mode}`,
    DEMAND_PREVIEW_OFFER_MODE_SECTION: (id, stage, supplierId, mode) => `${DEMAND_PREVIEW_STAGE_OFFER_BASE(id, stage, supplierId)}/${mode}/section`,
    DEMAND_PREVIEW_OFFER_MODE_POSITION_ID: (id, stage, mode, positionId, supplierId) => `${DEMAND_PREVIEW_STAGE_OFFER_BASE(id, stage, supplierId)}/${mode}/position/${positionId}`,
    DEMAND_PREVIEW_OFFER_MODE_POSITION_ID_PRINT: (id, stage, mode, positionId, supplierId) => `${DEMAND_PREVIEW_STAGE_OFFER_BASE(id, stage, supplierId)}/${mode}/position/${positionId}/print`,
}

const integrations = {
    SHAREPOINT: (demandId) => `${DEMAND_BASE(demandId)}/sharepoint`,
    SHAREPOINT_DELETE: (demandId) => `${DEMAND_BASE(demandId)}/sharepoint/deleteData`,
    EZDRP: (demandId) => `${DEMAND_BASE(demandId)}/ezdrp`,
    EZDRP_SHARE_ARCHIVE: (demandId) => `${DEMAND_BASE(demandId)}/ezdrp/share/archive`,
    EZDPUW: (demandId) => `${DEMAND_BASE(demandId)}/ezdpuw`,
    EZDPUW_SHARE_ARCHIVE: (demandId) => `${DEMAND_BASE(demandId)}/ezdpuw/share/archive`,
    EZDPUW_DOCUMENTS: (demandId, caseId) => `${DEMAND_BASE(demandId)}/ezdpuw/${caseId}/documents`
}

const EZAMOWIENIA_BASE = `${BASE}/ezamowienia`
const ezamowienia = {
    EZAMOWIENIA_AUTHORIZATION_STATUS: `${EZAMOWIENIA_BASE}/authorizationStatus`,
    EZAMOWIENIA_REVOKE_TOKEN: `${EZAMOWIENIA_BASE}/revokeToken`,
}

const ANNUAL_REPORT_BASE = `${BASE}/annualReport`
const annualReport = {
    ANNUAL_REPORT: ANNUAL_REPORT_BASE,
    ANNUAL_REPORT_REPORT_YEAR: (year) => `${ANNUAL_REPORT_BASE}/year/${year}`,
    ANNUAL_REPORT_REPORT_YEAR_AVAILABLE_ORGS: (year) => `${ANNUAL_REPORT_BASE}/year/${year}/availableOrgs`,
    ANNUAL_REPORT_REPORT_ID: (reportId) => `${ANNUAL_REPORT_BASE}/report/${reportId}`,
    ANNUAL_REPORT_REPORT_ID_ACTION: (reportId, action) => `${ANNUAL_REPORT_BASE}/report/${reportId}/${action}`,
    ANNUAL_REPORT_REPORT_ID_FORM_NAME: (reportId, formName) => `${ANNUAL_REPORT_BASE}/report/${reportId}/form/${formName}`,
    ANNUAL_REPORT_REPORT_ID_INITIALIZE_FORM_NAME: (reportId, formName) => `${ANNUAL_REPORT_BASE}/report/${reportId}/initialize/${formName}`,
    ANNUAL_REPORT_REPORT_ID_INITIALIZE_FROM_PREV_FORM_NAME: (reportId, formName) => `${ANNUAL_REPORT_BASE}/report/${reportId}/copyFromPrev/${formName}`,
    ANNUAL_REPORT_REPORT_ID_INITIALIZE_FORM_NAME_TABLE_ID: (reportId, formName, tableIdentity) => `${ANNUAL_REPORT_BASE}/report/${reportId}/initialize/${formName}/${tableIdentity}`,
    ANNUAL_REPORT_DICTIONARIES: ANNUAL_REPORT_BASE + "/dictionaries",
    ANNUAL_REPORT_TRANSLATIONS: ANNUAL_REPORT_BASE + "/translations",
}

const CONTRACT_NOTICE = (demandId) => `${DEMAND_BASE(demandId)}/nationalNotice/contractNotice`
const nationalContractNotice = {
    NATIONAL_NOTICE_VALIDATE: (demandId) => `${DEMAND_BASE(demandId)}/nationalNotice/validate`,
    NATIONAL_NOTICE_CONTRACT_NOTICE: (demandId) => `${CONTRACT_NOTICE(demandId)}`,
    NATIONAL_NOTICE_CONTRACT_NOTICE_CREATE_NEW_VERSION: (demandId) => `${CONTRACT_NOTICE(demandId)}/createNewVersion`,
    NATIONAL_NOTICE_CONTRACT_NOTICE_DRAFT: (demandId) => `${CONTRACT_NOTICE(demandId)}/draft`,
    NATIONAL_NOTICE_CONTRACT_NOTICE_TRANSLATIONS: (demandId) => `${CONTRACT_NOTICE(demandId)}/translations`,
    NATIONAL_NOTICE_CONTRACT_NOTICE_DICTIONARIES: (demandId) => `${CONTRACT_NOTICE(demandId)}/dictionaries`,
    NATIONAL_NOTICE_CONTRACT_NOTICE_PUBLISH: (demandId) => `${CONTRACT_NOTICE(demandId)}/publish`,
    NATIONAL_NOTICE_CONTRACT_NOTICE_PUBLISH_UPDATE: (demandId) => `${CONTRACT_NOTICE(demandId)}/publishUpdate`,
    NATIONAL_NOTICE_CONTRACT_NOTICE_PUBLISH_ROLLBACK: (demandId) => `${CONTRACT_NOTICE(demandId)}/publish/rollback`,
    NATIONAL_NOTICE_CONTRACT_NOTICE_PUBLISH_UPDATE_ROLLBACK: (demandId) => `${CONTRACT_NOTICE(demandId)}/publishUpdate/rollback`,
    NATIONAL_NOTICE_CONTRACT_NOTICE_STATUS: (demandId) => `${CONTRACT_NOTICE(demandId)}/status`,
    NATIONAL_NOTICE_CONTRACT_MODIFICATION_NOTICE_STATUS: (demandId) => `${CONTRACT_NOTICE(demandId)}/modification/status`,
    NATIONAL_NOTICE_CONTRACT_NOTICE_DYNAMIC_DICTIONARIES: (demandId) => `${CONTRACT_NOTICE(demandId)}/dynamicDictionaries`,
    NATIONAL_NOTICE_BZP_NOTICE_CONTENT: (demandId) => `${DEMAND_BASE(demandId)}/nationalNotice/bzpNoticeContent`,
}

const TENDER_RESULT_NOTICE = (demandId) => `${DEMAND_BASE(demandId)}/nationalNotice/tenderResultNotice`
const nationalTenderResultNotice = {
    NATIONAL_NOTICE_VALIDATE: (demandId) => `${DEMAND_BASE(demandId)}/nationalNotice/validate`,
    NATIONAL_NOTICE_TENDER_RESULT_NOTICE: (demandId) => `${TENDER_RESULT_NOTICE(demandId)}`,
    NATIONAL_NOTICE_TENDER_RESULT_NOTICE_CREATE_NEW_VERSION: (demandId) => `${TENDER_RESULT_NOTICE(demandId)}/createNewVersion`,
    NATIONAL_NOTICE_TENDER_RESULT_NOTICE_DRAFT: (demandId) => `${TENDER_RESULT_NOTICE(demandId)}/draft`,
    NATIONAL_NOTICE_TENDER_RESULT_NOTICE_TRANSLATIONS: (demandId) => `${TENDER_RESULT_NOTICE(demandId)}/translations`,
    NATIONAL_NOTICE_TENDER_RESULT_NOTICE_DICTIONARIES: (demandId) => `${TENDER_RESULT_NOTICE(demandId)}/dictionaries`,
    NATIONAL_NOTICE_TENDER_RESULT_NOTICE_PUBLISH: (demandId) => `${TENDER_RESULT_NOTICE(demandId)}/publish`,
    NATIONAL_NOTICE_TENDER_RESULT_NOTICE_PUBLISH_UPDATE: (demandId) => `${TENDER_RESULT_NOTICE(demandId)}/publishUpdate`,
    NATIONAL_NOTICE_TENDER_RESULT_NOTICE_STATUS: (demandId) => `${TENDER_RESULT_NOTICE(demandId)}/status`,
    NATIONAL_NOTICE_TENDER_RESULT_NOTICE_DYNAMIC_DICTIONARIES: (demandId) => `${TENDER_RESULT_NOTICE(demandId)}/dynamicDictionaries`,
    NATIONAL_NOTICE_TENDER_RESULT_NOTICE_CONTENT: (demandId, resultNoticeId) => `${DEMAND_BASE(demandId)}/nationalNotice/resultNoticeContent/${resultNoticeId}`,
}

const DEMAND_APPROVAL_BASE = (demandId) => `${DEMAND_BASE(demandId)}/approval`;
const demandApproval = {
    DEMAND_APPROVAL: DEMAND_APPROVAL_BASE,
    DEMAND_APPROVAL_SELECT_APPROVERS: (demandId) => `${DEMAND_APPROVAL_BASE(demandId)}/selectApprovers`,
    DEMAND_APPROVAL_SEND_DECISION: (demandId) => `${DEMAND_APPROVAL_BASE(demandId)}/sendDecision`,
    DEMAND_APPROVAL_RESET: (demandId) => `${DEMAND_APPROVAL_BASE(demandId)}/reset`,
    DEMAND_APPROVAL_STOP: (demandId) => `${DEMAND_APPROVAL_BASE(demandId)}/stop`,
    DEMAND_APPROVAL_HISTORY_LIST: (demandId) => `${DEMAND_APPROVAL_BASE(demandId)}/history`,
    DEMAND_APPROVAL_HISTORY: (demandId, approvalId) => `${DEMAND_APPROVAL_BASE(demandId)}/history/${approvalId}`,
    DEMAND_APPROVAL_HISTORY_GET_APPROVERS: (demandId, approvalId, stageId) => `${DEMAND_APPROVAL_BASE(demandId)}/history/getAvailableApprovers/${approvalId}/${stageId}`,
    DEMAND_APPROVAL_HISTORY_ADD_APPROVERS: (demandId, approvalId, stageId) => `${DEMAND_APPROVAL_BASE(demandId)}/history/addApprovers/${approvalId}/${stageId}`,
    DEMAND_APPROVAL_HISTORY_DELETE_APPROVER: (demandId, approvalId, stageId) => `${DEMAND_APPROVAL_BASE(demandId)}/history/deleteApprover/${approvalId}/${stageId}`,
    DEMAND_APPROVAL_VALIDATE: (demandId) => `${DEMAND_APPROVAL_BASE(demandId)}/validate`
}

const PURCHASING_GROUP_ID = (groupId) => `${base.PURCHASING_GROUP}/${groupId}`
const purchasingGroup = {
    PURCHASING_GROUP_LIST: () => `${base.PURCHASING_GROUP}/list`,
    PURCHASING_GROUP_LIST_ACTIONS: () => `${base.PURCHASING_GROUP}/list/actions`,
    PURCHASING_GROUP_MEMBER_LIST: () => `${base.PURCHASING_GROUP}/member/list`,
    PURCHASING_GROUP_HEADER: (groupId) => `${PURCHASING_GROUP_ID(groupId)}/header`,
    PURCHASING_GROUP_RELATED_OBJECTS: (groupId) => `${PURCHASING_GROUP_ID(groupId)}/relatedObjects`,
    PURCHASING_GROUP_BASIC_DATA: (groupId) => `${PURCHASING_GROUP_ID(groupId)}/basicData`,
    PURCHASING_GROUP_ARCHIVE_LIST: (groupId, archiveType) => `${PURCHASING_GROUP_ID(groupId)}/archiveList/${archiveType}`,
    PURCHASING_GROUP_ARCHIVE_ID: (groupId, archiveType, archiveId) => `${PURCHASING_GROUP_ID(groupId)}/archive/${archiveType}/${archiveId}`,

    PURCHASING_GROUP_COMMISSION: (groupId) => `${PURCHASING_GROUP_ID(groupId)}/commission`,
    PURCHASING_GROUP_COMMISSION_HISTORY: (groupId) => `${PURCHASING_GROUP_ID(groupId)}/commission/history`,
    PURCHASING_GROUP_COMMISSION_MARK_HISTORICAL: (groupId, id) => `${PURCHASING_GROUP_ID(groupId)}/commission/markHistorical/${id}`,

    PURCHASING_GROUP_SCHEDULE: (groupId) => `${PURCHASING_GROUP_ID(groupId)}/schedule`,

    PURCHASING_GROUP_MEMBERS: (groupId) => `${PURCHASING_GROUP_ID(groupId)}/members`,
    PURCHASING_GROUP_MEMBERS_AVAILABLE_CONCERNS: (groupId) => `${PURCHASING_GROUP_ID(groupId)}/members/availableConcerns`,
    PURCHASING_GROUP_MEMBERS_MEMBER: (groupId) => `${PURCHASING_GROUP_ID(groupId)}/members/member`,
    PURCHASING_GROUP_MEMBERS_MEMBER_ID: (groupId, memberId) => `${PURCHASING_GROUP_ID(groupId)}/members/member/${memberId}`,
    PURCHASING_GROUP_MEMBERS_MEMBER_ID_REJECT: (groupId, memberId) => `${PURCHASING_GROUP_ID(groupId)}/members/member/${memberId}/reject`,
    PURCHASING_GROUP_MEMBERS_MEMBER_ID_RESTORE: (groupId, memberId) => `${PURCHASING_GROUP_ID(groupId)}/members/member/${memberId}/restore`,
    PURCHASING_GROUP_MEMBERS_MEMBER_ID_CONFIRM_PARTICIPATION: (groupId, memberId) => `${PURCHASING_GROUP_ID(groupId)}/members/member/${memberId}/confirmParticipation`,
    PURCHASING_GROUP_MEMBERS_MEMBER_ID_WITHDRAW_PARTICIPATION: (groupId, memberId) => `${PURCHASING_GROUP_ID(groupId)}/members/member/${memberId}/withdrawParticipation`,

    PURCHASING_GROUP_MEMBERS_MEMBER_ID_RESEND_INVITE_NOTIFICATION: (groupId, memberId) => `${PURCHASING_GROUP_ID(groupId)}/members/member/${memberId}/resendInviteNotification`,

    PURCHASING_GROUP_MEMBERS_MEMBER_ID_DOCUMENT: (groupId, memberId) => `${PURCHASING_GROUP_ID(groupId)}/members/member/${memberId}/document`,
    PURCHASING_GROUP_MEMBERS_MEMBER_ID_DOCUMENT_ID: (groupId, memberId, documentId) => `${PURCHASING_GROUP_ID(groupId)}/members/member/${memberId}/document/${documentId}`,
    PURCHASING_GROUP_MEMBERS_MEMBER_ID_DOCUMENT_ID_URL: (groupId, memberId, documentId, open) => `${PURCHASING_GROUP_ID(groupId)}/members/member/${memberId}/document/${documentId}/url/${open ? "open" : "download"}`,
    PURCHASING_GROUP_MEMBERS_MEMBER_ID_USER: (groupId, memberId) => `${PURCHASING_GROUP_ID(groupId)}/members/member/${memberId}/user`,
    PURCHASING_GROUP_MEMBERS_MEMBER_ID_USER_ID: (groupId, memberId, userId) => `${PURCHASING_GROUP_ID(groupId)}/members/member/${memberId}/user/${userId}`,


    PURCHASING_GROUP_MEMBERS_DOCUMENTS: (groupId, apiPath) => `${PURCHASING_GROUP_ID(groupId)}/${apiPath}/documents`,
    PURCHASING_GROUP_MEMBERS_DOCUMENTS_GENERATE_GROUP_AGREEMENT: (groupId) => `${PURCHASING_GROUP_ID(groupId)}/members/documents/generateGroupAgreementDocument`,
    PURCHASING_GROUP_MEMBERS_DOCUMENTS_ID: (groupId, apiPath, documentId) => `${PURCHASING_GROUP_ID(groupId)}/${apiPath}/documents/${documentId}`,
    PURCHASING_GROUP_MEMBERS_DOCUMENTS_ID_PUBLISH: (groupId, apiPath, documentId) => `${PURCHASING_GROUP_ID(groupId)}/${apiPath}/documents/${documentId}/publish`,
    PURCHASING_GROUP_MEMBERS_DOCUMENTS_ID_UNPUBLISH: (groupId, apiPath, documentId) => `${PURCHASING_GROUP_ID(groupId)}/${apiPath}/documents/${documentId}/unpublish`,
    PURCHASING_GROUP_MEMBERS_DOCUMENTS_ID_URL: (groupId, apiPath, documentId, open) => `${PURCHASING_GROUP_ID(groupId)}/${apiPath}/documents/${documentId}/url/${open ? "open" : "download"}`,

    PURCHASING_GROUP_SWZ_DOCUMENTS: (groupId) => `${PURCHASING_GROUP_ID(groupId)}/swz/documents`,
    PURCHASING_GROUP_SWZ_DOCUMENTS_ID: (groupId, documentId) => `${PURCHASING_GROUP_ID(groupId)}/swz/documents/${documentId}`,
    PURCHASING_GROUP_SWZ_DOCUMENTS_ID_PUBLISH: (groupId, documentId) => `${PURCHASING_GROUP_ID(groupId)}/swz/documents/${documentId}/publish`,
    PURCHASING_GROUP_SWZ_DOCUMENTS_ID_UNPUBLISH: (groupId, documentId) => `${PURCHASING_GROUP_ID(groupId)}/swz/documents/${documentId}/unpublish`,
    PURCHASING_GROUP_SWZ_DOCUMENTS_ID_URL: (groupId, documentId, open) => `${PURCHASING_GROUP_ID(groupId)}/swz/documents/${documentId}/url/${open ? "open" : "download"}`,


    PURCHASING_GROUP_OPINION: (groupId, type) => `${PURCHASING_GROUP_ID(groupId)}/opinion/${type}`,
    PURCHASING_GROUP_OPINION_ID: (groupId, type, opinionId) => `${PURCHASING_GROUP_ID(groupId)}/opinion/${type}/${opinionId}`,
    PURCHASING_GROUP_OPINION_ID_MARK_AS_READ: (groupId, type, opinionId) => `${PURCHASING_GROUP_ID(groupId)}/opinion/${type}/${opinionId}/markAsRead`,
    PURCHASING_GROUP_OPINION_AVAILABLE_MEMBERS: (groupId, type) => `${PURCHASING_GROUP_ID(groupId)}/opinion/${type}/availableMembers`,
    PURCHASING_GROUP_OPINION_MEMBER_ID: (groupId, type, memberId) => `${PURCHASING_GROUP_ID(groupId)}/opinion/${type}/member/${memberId}`,
    PURCHASING_GROUP_OPINION_ID_MESSAGE_NEW: (groupId, type, opinionId) => `${PURCHASING_GROUP_ID(groupId)}/opinion/${type}/${opinionId}/message/new`,
    PURCHASING_GROUP_OPINION_ID_MESSAGE_ID: (groupId, type, opinionId, messageId) => `${PURCHASING_GROUP_ID(groupId)}/opinion/${type}/${opinionId}/message/${messageId}`,


    PURCHASING_GROUP_FINISH_PREPARING: (groupId) => `${PURCHASING_GROUP_ID(groupId)}/finishPreparing`,

    PURCHASING_GROUP_MEMBERS_PAPERS_GENERATOR_TEMPLATE_FORM_EXPORT: (groupId) => `${PURCHASING_GROUP_ID(groupId)}/papersGenerator/templateFormExport`,
    PURCHASING_GROUP_MEMBERS_PAPERS_GENERATOR_GZM_LEADING_DOCUMENT: (groupId) => `${PURCHASING_GROUP_ID(groupId)}/papersGenerator/gzmLeadingDocument`,
    PURCHASING_GROUP_MEMBERS_PAPERS_GENERATOR_GZM_MANAGEMENT_RESOLUTION: (groupId) => `${PURCHASING_GROUP_ID(groupId)}/papersGenerator/gzmManagementResolution`,
    PURCHASING_GROUP_MEMBERS_PAPERS_GENERATOR_GZM_DRAFT_GROUP_AGREEMENT: (groupId) => `${PURCHASING_GROUP_ID(groupId)}/papersGenerator/gzmDraftGroupAgreement`,
    PURCHASING_GROUP_MEMBERS_PAPERS_GENERATOR_GZM_DOCUMENT_TO_SIGN: (groupId) => `${PURCHASING_GROUP_ID(groupId)}/papersGenerator/gzmDocumentToSign`,

    PURCHASING_GROUP_COLLECTING_SCHEDULE: (groupId) => `${PURCHASING_GROUP_ID(groupId)}/collectingSchedule`,

    PURCHASING_GROUP_COLLECTING_TEMPLATE: (groupId) => `${PURCHASING_GROUP_ID(groupId)}/template`,
    PURCHASING_GROUP_COLLECTING_TEMPLATE_AVAILABLE: (groupId) => `${PURCHASING_GROUP_ID(groupId)}/template/availableTemplates`,
    PURCHASING_GROUP_COLLECTING_TEMPLATE_MEMBER_ID: (groupId, memberId) => `${PURCHASING_GROUP_ID(groupId)}/template/member/${memberId}`,
    PURCHASING_GROUP_COLLECTING_TEMPLATE_MEMBER_FORM_ID: (groupId, memberId, formId) => `${PURCHASING_GROUP_ID(groupId)}/template/member/${memberId}/form/${formId}`,
    PURCHASING_GROUP_COLLECTING_TEMPLATE_MEMBER_FORM_ID_DRAFT: (groupId, memberId, formId) => `${PURCHASING_GROUP_ID(groupId)}/template/member/${memberId}/form/${formId}/draft`,
    PURCHASING_GROUP_COLLECTING_TEMPLATE_MEMBER_FORM_ID_CLEAR_DRAFT: (groupId, memberId, formId) => `${PURCHASING_GROUP_ID(groupId)}/template/member/${memberId}/form/${formId}/clearDraft`,
    PURCHASING_GROUP_COLLECTING_TEMPLATE_MEMBER_FORM_ID_ACCEPT: (groupId, memberId, formId) => `${PURCHASING_GROUP_ID(groupId)}/template/member/${memberId}/form/${formId}/accept`,
    PURCHASING_GROUP_COLLECTING_TEMPLATE_MEMBER_FORM_ID_REJECT: (groupId, memberId, formId) => `${PURCHASING_GROUP_ID(groupId)}/template/member/${memberId}/form/${formId}/reject`,
    PURCHASING_GROUP_COLLECTING_TEMPLATE_MEMBER_FORM_ID_ASK_FOR_EDIT: (groupId, memberId, formId) => `${PURCHASING_GROUP_ID(groupId)}/template/member/${memberId}/form/${formId}/askForEdit`,
    PURCHASING_GROUP_COLLECTING_TEMPLATE_MEMBER_FORM_ID_ALLOW_EDIT: (groupId, memberId, formId) => `${PURCHASING_GROUP_ID(groupId)}/template/member/${memberId}/form/${formId}/allowEdit`,
    PURCHASING_GROUP_COLLECTING_TEMPLATE_MEMBER_FORM_ID_REJECT_EDIT: (groupId, memberId, formId) => `${PURCHASING_GROUP_ID(groupId)}/template/member/${memberId}/form/${formId}/rejectEdit`,
    PURCHASING_GROUP_COLLECTING_TEMPLATE_MEMBER_FORM_ID_ARCHIVE_LIST: (groupId, memberId, formId) => `${PURCHASING_GROUP_ID(groupId)}/template/member/${memberId}/form/${formId}/archiveList`,
    PURCHASING_GROUP_COLLECTING_TEMPLATE_MEMBER_FORM_ID_ARCHIVE_ID: (groupId, memberId, formId, archiveId) => `${PURCHASING_GROUP_ID(groupId)}/template/member/${memberId}/form/${formId}/archive/${archiveId}`,

    PURCHASING_GROUP_FINISH: (groupId) => `${PURCHASING_GROUP_ID(groupId)}/finish`,
    PURCHASING_GROUP_FINISH_DEALINGS_CHANGED: (groupId) => `${PURCHASING_GROUP_ID(groupId)}/finish/sendDealingsChangedNotification`

}

const PURCHASING_GROUP_SECTIONS = (groupId) => `${PURCHASING_GROUP_ID(groupId)}/sections`

const purchasingGroupSections = {
    PURCHASING_GROUP_SECTIONS_PREPARING: (groupId) => `${PURCHASING_GROUP_SECTIONS(groupId)}/preparing`,
    PURCHASING_GROUP_SECTIONS_COLLECTING_DATA: (groupId) => `${PURCHASING_GROUP_SECTIONS(groupId)}/collectingData`,
    PURCHASING_GROUP_SECTIONS_SECTION: (groupId) => `${PURCHASING_GROUP_SECTIONS(groupId)}/section`
}

const PURCHASING_GROUP_TEMPLATES = `${base.PURCHASING_GROUP}/template`

const purchasingGroupTemplate = {
    PURCHASING_GROUP_TEMPLATES_LIST: () => `${PURCHASING_GROUP_TEMPLATES}/list`,
    PURCHASING_GROUP_TEMPLATES_LIST_HAS_EDIT: () => `${PURCHASING_GROUP_TEMPLATES}/list/hasEdit`,
    PURCHASING_GROUP_TEMPLATES_TEMPLATE_ID: (templateId) => `${PURCHASING_GROUP_TEMPLATES}/${templateId}`,
    PURCHASING_GROUP_TEMPLATES_TEMPLATE_ID_ACTIVATE: (templateId) => `${PURCHASING_GROUP_TEMPLATES}/${templateId}/activate`,
    PURCHASING_GROUP_TEMPLATES_TEMPLATE_ID_DEACTIVATE: (templateId) => `${PURCHASING_GROUP_TEMPLATES}/${templateId}/deactivate`,
    PURCHASING_GROUP_TEMPLATES_TEMPLATE_ID_CLONE: (templateId) => `${PURCHASING_GROUP_TEMPLATES}/${templateId}/clone`,
}

const ADMIN_USER_REGISTRATION = `${base.ADMIN}/user/registration`

const adminUserRegistrations = {
    ADMIN_USER_REGISTRATION_LIST: `${ADMIN_USER_REGISTRATION}/list`,
    ADMIN_USER_REGISTRATION_AVAILABLE_ORGS: `${ADMIN_USER_REGISTRATION}/availableOrgs`,
    ADMIN_USER_REGISTRATION_ID: (regId) => `${ADMIN_USER_REGISTRATION}/${regId}`,
    ADMIN_USER_REGISTRATION_ID_REJECT: (regId) => `${ADMIN_USER_REGISTRATION}/${regId}/reject`,
    ADMIN_USER_REGISTRATION_ID_ACCEPT: (regId) => `${ADMIN_USER_REGISTRATION}/${regId}/accept`,
    ADMIN_USER_REGISTRATION_ID_ORGANIZATION: (regId) => `${ADMIN_USER_REGISTRATION}/${regId}/organization`
}

const audit = {
    AUDIT_LIST_ADMIN: `${base.AUDIT}/list/admin`,
    AUDIT_LIST: `${base.AUDIT}/list`,
    AUDIT_ALLOWED_OBJECT_LIST: `${base.AUDIT}/allowedObject/list`,
    AUDIT: (taskId) => `${base.AUDIT}/${taskId}`,
    AUDIT_ADMIN_SAVE: () => `${base.AUDIT}/admin`,
    AUDIT_ADMIN: (taskId) => `${base.AUDIT}/admin/${taskId}`,
    AUDIT_ADMIN_USERS: (taskId) => `${base.AUDIT}/admin/${taskId}/availableUsers`,
    AUDIT_ADMIN_ALLOWED_OBJECTS: (taskId, objectType) => `${base.AUDIT}/admin/${taskId}/availableObjects/${objectType}`,
    AUDIT_ADMIN_ORGANIZATIONS: (taskId) => `${base.AUDIT}/admin/${taskId}/availableOrganizations`,
    AUDIT_CLONE: (taskId) => `${base.AUDIT}/admin/${taskId}/clone`,
    AUDIT_HISTORY: (taskId) =>  `${base.AUDIT}/admin/${taskId}/history`,
    AUDIT_HISTORY_PRINT: (taskId) =>  `${base.AUDIT}/admin/${taskId}/history/print`
}

const enotices = {
    ENOTICES_GENERATE_LINK: (demandId) => `${base.ENOTICES}/${demandId}/generateLink`,
    ENOTICES_CREATE: (demandId) => `${base.ENOTICES}/${demandId}/create`,
    ENOTICES_CREATE_CHANGE: (demandId) => `${base.ENOTICES}/${demandId}/create/change`,
    ENOTICES_STATUS: (demandId) => `${base.ENOTICES}/${demandId}/status`,
    ENOTICES_PREVIEW: `${base.ENOTICES}/list`,
    ENOTICES_PUBLISH: (demandId) => `${base.ENOTICES}/${demandId}/publish`,
    ENOTICES_WITHDRAW: (demandId) => `${base.ENOTICES}/${demandId}/withdraw-notice`,
    ENOTICES_VALIDATE: (demandId) => `${base.ENOTICES}/${demandId}/validate`,
    ENOTICES_VALIDATE_TED: (demandId) => `${base.ENOTICES}/${demandId}/ted/status`,
    ENOTICES_VALIDATE_TED_LOCAL: (demandId) => `${base.ENOTICES}/${demandId}/ted/local/status`,
    ENOTICES_ANNOUNCEMENT_STATUS: (demandId) => `${base.ENOTICES}/${demandId}/ted/announcement/status`,
    ENOTICES_RENDER: (demandId) => `${base.ENOTICES}/${demandId}/render`,
    ENOTICES_DELETE: (demandId) => `${base.ENOTICES}/${demandId}/delete`,
}

const CONTRACT_PERFORMING_NOTICE = (agreementId) => `${base.AGREEMENT}/${agreementId}/nationalNotice/contractPerformingNotice`
const contractPerformingNotice = {
    NATIONAL_NOTICE_CONTRACT_PERFORMING_NOTICE: (agreementId, positionIds = []) => {
        const q = Array.isArray(positionIds) && positionIds.length ? `?partsId=${positionIds.join(",")}` : "";
        return `${CONTRACT_PERFORMING_NOTICE(agreementId)}${q}`;
      },
      NATIONAL_NOTICE_CONTRACT_PERFORMING_NOTICE_BY_ID: (agreementId, noticeId) => `${CONTRACT_PERFORMING_NOTICE(agreementId)}/${noticeId}`,
      NATIONAL_NOTICE_CONTRACT_PERFORMING_NOTICE_CREATE_NEW_VERSION: (agreementId, positionIds = []) => {
        const q = Array.isArray(positionIds) && positionIds.length ? `?partsId=${positionIds.join(",")}` : "";
        return `${CONTRACT_PERFORMING_NOTICE(agreementId)}/createNewVersion${q}`;
      },
    NATIONAL_NOTICE_CONTRACT_PERFORMING_NOTICE_DRAFT: (agreementId) => `${CONTRACT_PERFORMING_NOTICE(agreementId)}/draft`,
    NATIONAL_NOTICE_CONTRACT_PERFORMING_NOTICE_DICTIONARIES: (agreementId) => `${CONTRACT_PERFORMING_NOTICE(agreementId)}/dictionaries`,
    NATIONAL_NOTICE_CONTRACT_PERFORMING_NOTICE_TRANSLATIONS: (agreementId) => `${CONTRACT_PERFORMING_NOTICE(agreementId)}/translations`,
}

const customerio = {
    CUSTOMER_IO: () => `${base.BASE}/customerio`
}

const extensions = () => `${base.BASE}/file/extensions`
const hotJarSettings = {hjid: 1296211, hjsv: 6}

export default {
    redirect_uri,
    oauth,
    ...base,
    ...sales,
    ...demand,
    ...user,
    ...schedule,
    ...siwz,
    ...contractor,
    ...commission,
    ...espd,
    ...guarantee,
    ...contractor,
    ...user,
    ...header,
    ...client,
    ...notice,
    ...repo,
    ...publish,
    ...dealings,
    ...dealing,
    ...statistic,
    ...supplier,
    ...offers,
    ...modification,
    ...rfxRound,
    ...correspondenceBuyer,
    ...correspondenceContractor,
    ...papersGenerator,
    ...emailList,
    ...sections,
    ...contractorVerification,
    ...offerEvaluation,
    ...offerChoice,
    ...offerChoiceResult,
    ...agreements,
    ...evaluationFinish,
    ...resultNotice,
    ...finishDemand,
    ...archiving,
    ...additionalRound,
    ...demandAdditionalInfo,
    ...auction,
    ...additionalRoundsPassive,
    ...demandPlanRealization,
    ...poll,
    ...integrations,
    ...demandOffers,
    ...ezamowienia,
    ...nationalContractNotice,
    ...nationalTenderResultNotice,
    ...purchasingGroup,
    ...purchasingGroupSections,
    ...purchasingGroupTemplate,
    ...adminUserRegistrations,
    ...demandOffers,
    ...demandOffersGeneralInfo,
    ...demandOffersOffer,
    ...demandAdditionalOffersOffer,
    ...demandAdditionalAuction,
    ...demandOffersAccess,
    ...demandPublicationPreview,
    ...annualReport,
    ...demandApproval,
    ...offerChoiceApproval,
    ...audit,
    ...enotices,
    ...contractPerformingNotice,
    ...customerio,
    extensions,
    SERVER_URL,
    EXT_JS_LIBRARIES,
    hotJarSettings,
}